import React, { useState, useEffect, useRef } from "react";
import { useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faImage, faVideo, faFileAudio, faSpinner, faDollarSign,
  faCrown, faBan, faPhone, faPlus, faEdit, faGem, faArrowDown,
  faTrash, faEyeSlash, faStickyNote, faExclamationTriangle, faStar, faTimes,
  faHeart, faHistory, faComments, faBirthdayCake, faMapMarkerAlt, faEnvelope, faCoins, faUser, faClock, faBell, faImages, faGift, faMobileAlt
} from '@fortawesome/free-solid-svg-icons';
import { faHeart as faHeartRegular } from '@fortawesome/free-regular-svg-icons';
import {
  Card, Form, Button, Table, InputGroup, Alert, Badge, Modal,
  Row, Col, OverlayTrigger, Tooltip
} from '@themesberg/react-bootstrap';
import { httpsCallable } from 'firebase/functions';
import {
  collection, query, getDocs, orderBy, limit, getDoc, doc,
  addDoc, updateDoc, serverTimestamp, onSnapshot, Timestamp,
  deleteDoc, where, setDoc
} from 'firebase/firestore';
import { uploadToR2, generateUUID } from '../../utils/r2Upload';
import { db, auth, functions } from '../../config/firebase';

// Avatar Component - Hata durumunda placeholder gösterir
const AvatarComponent = ({ avatar, name, size = 40 }) => {
  const [imageError, setImageError] = React.useState(false);

  if (!avatar || imageError) {
    return (
      <div
        className="rounded-circle me-2 d-flex align-items-center justify-content-center text-white"
        style={{
          width: size,
          height: size,
          backgroundColor: '#6c757d',
          fontSize: size * 0.4 + 'px',
          fontWeight: 'bold',
          flexShrink: 0
        }}
      >
        {(name || 'U')[0].toUpperCase()}
      </div>
    );
  }

  return (
    <img
      src={avatar}
      alt={name || 'User'}
      className="rounded-circle me-2"
      style={{
        width: size,
        height: size,
        objectFit: 'cover',
        backgroundColor: '#6c757d',
        flexShrink: 0
      }}
      onError={() => setImageError(true)}
    />
  );
};

export default () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const urlRoomId = queryParams.get('roomId');
  const urlSenderId = queryParams.get('senderId');
  const urlReceiverId = queryParams.get('receiverId');
  const [unrepliedMessages, setUnrepliedMessages] = useState([]);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // URL üzerinden gelen isteği kontrol et
  useEffect(() => {
    if (urlRoomId && urlSenderId && urlReceiverId && !selectedMessage) {
      const overrideMsg = {
        id: 'manual_id',
        chatRoomId: urlRoomId,
        roomId: urlRoomId,
        sender: { id: urlSenderId, name: 'Kullanıcı' },
        receiver: { id: urlReceiverId, name: 'Pinki Destek' }
      };
      setCurrentRoomId(urlRoomId);
      setCurrentSenderId(urlSenderId);
      setCurrentReceiverId(urlReceiverId);
      setSelectedMessage(overrideMsg);
    }
  }, [urlRoomId, urlSenderId, urlReceiverId]);


  // MessageReplyScreen state'leri
  const [userInfo, setUserInfo] = useState(null);
  const [testUserInfo, setTestUserInfo] = useState(null);
  const [messages, setMessages] = useState([]);
  const [messageText, setMessageText] = useState("");
  const [sending, setSending] = useState(false);
  const [isBlockedByUser, setIsBlockedByUser] = useState(false);
  const [userCredits, setUserCredits] = useState(0);
  const [userIsPremium, setUserIsPremium] = useState(false);
  const [userPremiumExpiresAt, setUserPremiumExpiresAt] = useState(null);
  const [userIsBanned, setUserIsBanned] = useState(false);
  const [userIsTestUser, setUserIsTestUser] = useState(false);
  const [testUserCredits, setTestUserCredits] = useState(0);
  const [testUserIsPremium, setTestUserIsPremium] = useState(false);
  const [testUserPremiumExpiresAt, setTestUserPremiumExpiresAt] = useState(null);
  const [testUserIsTestUser, setTestUserIsTestUser] = useState(false);
  const [showCreditsModal, setShowCreditsModal] = useState(false);
  const [showPremiumModal, setShowPremiumModal] = useState(false);
  const [showBanModal, setShowBanModal] = useState(false);
  const [showCallModal, setShowCallModal] = useState(false);
  const [showQuickMessageModal, setShowQuickMessageModal] = useState(false);
  const [showDiamondModal, setShowDiamondModal] = useState(false);
  const [quickMessages, setQuickMessages] = useState([]);
  const [creditsInput, setCreditsInput] = useState("");
  const [premiumDaysInput, setPremiumDaysInput] = useState("");
  const [callType, setCallType] = useState("normal_voice");
  const [selectedRecordingIndex, setSelectedRecordingIndex] = useState(0);
  const [audioRecordings, setAudioRecordings] = useState([]);
  const [videoRecordings, setVideoRecordings] = useState([]);
  const [quickMessageTitle, setQuickMessageTitle] = useState("");
  const [quickMessageContent, setQuickMessageContent] = useState("");
  const [editingQuickMessage, setEditingQuickMessage] = useState(null);
  const [quickMessageScale, setQuickMessageScale] = useState(1);
  const [isSmart, setIsSmart] = useState(false);
  const [targetUserId, setTargetUserId] = useState(null);
  const [appSettings, setAppSettings] = useState(null);
  const [coinSettings, setCoinSettings] = useState({
    messageCoin: 1,
    imageCoin: 20,
    videoCoin: 0,
    audioCoin: 0,
    callCoin: 150
  });
  const messageTextareaRef = useRef(null);
  const creditsInputRef = useRef(null);
  const premiumInputRef = useRef(null);
  const [currentRoomId, setCurrentRoomId] = useState(null);
  const [currentSenderId, setCurrentSenderId] = useState(null);
  const [currentReceiverId, setCurrentReceiverId] = useState(null);
  const [conversationNotes, setConversationNotes] = useState([]);
  const [noteFilter, setNoteFilter] = useState('all');
  const [noteType, setNoteType] = useState('bot');
  const [noteContent, setNoteContent] = useState("");
  const [expandedImages, setExpandedImages] = useState(new Set()); // Açık resimlerin ID'leri
  const [newlySentImages, setNewlySentImages] = useState(new Set()); // Yeni gönderilen resimler (ilk gönderimde gösterilsin)
  const [showAllImages, setShowAllImages] = useState(false); // Tüm resimleri göster/gizle (admin panel için)
  const [expandedVideos, setExpandedVideos] = useState(new Set()); // Açık videoların ID'leri
  const [newlySentVideos, setNewlySentVideos] = useState(new Set()); // Yeni gönderilen videolar (ilk gönderimde gösterilsin)
  const [showAllVideos, setShowAllVideos] = useState(false); // Tüm videoları göster/gizle (admin panel için)
  const [showVipPhoneModal, setShowVipPhoneModal] = useState(false);
  const [vipPhoneMessage, setVipPhoneMessage] = useState('Değerli Kullanıcı telefon numaranızı veya sosyal medya hesabınızı paylaşmak için VIP üye olmalısınız. VIP paket satın almak için tıklayınız.');
  const [vipPhoneSelectedSku, setVipPhoneSelectedSku] = useState('');
  const [vipPackages, setVipPackages] = useState([]);
  const [showSystemMessageModal, setShowSystemMessageModal] = useState(false);
  const [systemMessageText, setSystemMessageText] = useState("");
  const [lastSystemMessage, setLastSystemMessage] = useState("");
  const [vipPhoneSending, setVipPhoneSending] = useState(false);
  const [pastedImage, setPastedImage] = useState(null);
  const [pastedImagePreview, setPastedImagePreview] = useState(null);

  // VIP Şablon state'leri
  const [vipTemplates, setVipTemplates] = useState([]);
  const [showVipTemplateModal, setShowVipTemplateModal] = useState(false);
  const [vipTemplateTitle, setVipTemplateTitle] = useState("");
  const [vipTemplateContent, setVipTemplateContent] = useState("");
  const [editingVipTemplate, setEditingVipTemplate] = useState(null);
  const [showRecordingModal, setShowRecordingModal] = useState(false);
  const [recordingModalType, setRecordingModalType] = useState('audio'); // 'audio' or 'video'
  const [uploading, setUploading] = useState(false);
  const [showNotificationModal, setShowNotificationModal] = useState(false);
  const [notificationTitle, setNotificationTitle] = useState("");
  const [notificationMessage, setNotificationMessage] = useState("");
  const [notificationSending, setNotificationSending] = useState(false);

  // Hediye (Gift) modal state
  const [showGiftModal, setShowGiftModal] = useState(false);
  const [gifts, setGifts] = useState([]);
  const [giftsLoading, setGiftsLoading] = useState(false);
  const [sendingGift, setSendingGift] = useState(null);

  const messageListRef = useRef(null);
  const selectedIndexRef = useRef(-1);

  // Favoriler ve Son Mesajlar için state'ler
  const [activeTab, setActiveTab] = useState('sohbetler'); // 'sohbetler', 'favoriler', 'sonMesajlar'
  const [favoriteChats, setFavoriteChats] = useState([]); // Favori sohbetler
  const [recentRepliedMessages, setRecentRepliedMessages] = useState([]); // Admin tarafından cevaplanan son 30 mesaj
  const [favoriteIds, setFavoriteIds] = useState(new Set()); // Favori sohbet ID'leri (hızlı lookup için)

  // Fake hesap arşivi için state'ler
  const [archivePhotos, setArchivePhotos] = useState([]); // Mevcut fake hesabın arşiv fotoğrafları
  const [showArchiveModal, setShowArchiveModal] = useState(false); // Arşiv modal göster/gizle
  const [archiveUploading, setArchiveUploading] = useState(false); // Fotoğraf yükleniyor mu

  // Real-time listener ile unansweredMessages koleksiyonunu dinle
  useEffect(() => {
    const unansweredQuery = query(
      collection(db, 'unansweredMessages'),
      orderBy('createdAt', 'desc')
    );

    const unsubscribe = onSnapshot(unansweredQuery, (snapshot) => {
      console.log(`QuickUnreplied updated: ${snapshot.docs.length} messages`);

      // Aynı chatRoom için sadece en son mesajı tut
      const latestMessagesByRoom = new Map();

      snapshot.docs.forEach(doc => {
        const data = doc.data();
        const roomId = data.chatRoomId;
        const timestamp = data.timestamp?.toDate ? data.timestamp.toDate() : new Date();

        // Eğer bu chatRoom için daha yeni bir mesaj yoksa ekle
        const existing = latestMessagesByRoom.get(roomId);
        if (!existing || timestamp > existing.date) {
          latestMessagesByRoom.set(roomId, {
            id: doc.id,
            roomId: roomId,
            sender: {
              id: data.senderId,
              name: data.senderName || 'Bilinmeyen',
              avatar: data.senderAvatar || null
            },
            receiver: {
              id: data.receiverId,
              name: data.receiverName || 'Bilinmeyen',
              avatar: data.receiverAvatar || null
            },
            message: data.message || (
              data.messageType === 'image' ? '📷 Fotoğraf' :
                data.messageType === 'video' ? '🎥 Video' :
                  data.messageType === 'audio' ? '🎤 Ses' : 'Mesaj'
            ),
            timestamp: data.timestamp,
            type: data.messageType || 'text',
            date: timestamp
          });
        }
      });

      // Map'i listeye çevir ve sırala
      const unrepliedList = Array.from(latestMessagesByRoom.values())
        .sort((a, b) => b.date.getTime() - a.date.getTime());

      setUnrepliedMessages(unrepliedList);
      setLoading(false);
    }, (err) => {
      console.error('Error listening to unreplied messages:', err);
      setError('Mesajlar yüklenirken bir hata oluştu.');
      setLoading(false);
    });

    // Unsubscribe
    return () => unsubscribe();
  }, []);

  // Quick messages ve app settings yükle
  useEffect(() => {
    loadQuickMessages();
    loadAppSettings();
    loadVipPackages();
    loadVipTemplates();
  }, []);

  const loadVipTemplates = async () => {
    try {
      const currentUser = auth.currentUser;
      if (!currentUser) return;

      const templatesRef = collection(db, 'users', currentUser.uid, 'vipTemplates');
      const snapshot = await getDocs(templatesRef);
      const templates = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setVipTemplates(templates);
    } catch (err) {
      console.error('Error loading VIP templates:', err);
    }
  };

  const handleSaveVipTemplate = async () => {
    if (!vipTemplateTitle.trim() || !vipTemplateContent.trim()) {
      alert("Lütfen başlık ve içerik girin.");
      return;
    }

    try {
      const currentUser = auth.currentUser;
      if (!currentUser) return;

      const templatesRef = collection(db, 'users', currentUser.uid, 'vipTemplates');

      if (editingVipTemplate) {
        await updateDoc(doc(db, 'users', currentUser.uid, 'vipTemplates', editingVipTemplate.id), {
          title: vipTemplateTitle,
          content: vipTemplateContent,
          updatedAt: serverTimestamp()
        });
      } else {
        await addDoc(templatesRef, {
          title: vipTemplateTitle,
          content: vipTemplateContent,
          createdAt: serverTimestamp()
        });
      }

      setShowVipTemplateModal(false);
      setEditingVipTemplate(null);
      setVipTemplateTitle("");
      setVipTemplateContent("");
      loadVipTemplates();
    } catch (err) {
      console.error('Error saving VIP template:', err);
      alert("Hata oluştu.");
    }
  };

  const handleDeleteVipTemplate = async (templateId) => {
    if (!window.confirm("Bu şablonu silmek istediğinize emin misiniz?")) return;

    try {
      const currentUser = auth.currentUser;
      await deleteDoc(doc(db, 'users', currentUser.uid, 'vipTemplates', templateId));
      loadVipTemplates();
    } catch (err) {
      console.error('Error deleting VIP template:', err);
    }
  };

  const loadVipPackages = async () => {
    try {
      // VIP paketlerini yükle
      const qVip = query(collection(db, "vipPackages"));
      const snapshotVip = await getDocs(qVip);
      const vips = snapshotVip.docs.map(doc => ({
        id: doc.id,
        type: 'VIP',
        ...doc.data()
      }));

      // Kredi paketlerini yükle
      const qCredit = query(collection(db, "creditPackages"));
      const snapshotCredit = await getDocs(qCredit);
      const credits = snapshotCredit.docs.map(doc => ({
        id: doc.id,
        type: 'Kredi',
        ...doc.data()
      }));

      // Birleştir ve set et
      setVipPackages([...vips, ...credits]);
    } catch (err) {
      console.error("Error loading packages:", err);
    }
  };

  // Klavye kısayolu: " tuşu ile alttaki sohbete geçiş
  useEffect(() => {
    const handleKeyPress = (e) => {
      if (e.key === '"' && unrepliedMessages.length > 0) {
        e.preventDefault();

        let nextIndex = 0;
        const currentIndex = selectedIndexRef.current;

        if (currentIndex >= 0) {
          // Mevcut seçili olan mesaj hala listede mi kontrol et
          const currentMessageExists = unrepliedMessages.some(m => m.id === selectedMessage?.id);

          if (currentMessageExists) {
            // Eğer cevaplamadan basıldıysa: Bir sonrakine (+1) geç
            nextIndex = currentIndex + 1;
          } else {
            // Eğer cevaplandığı için listeden silindiyse: Aynı index numarasındaki yeni mesajı seç
            nextIndex = currentIndex;
          }

          // Loop: Listenin sonuna gelindiyse başa dön
          if (nextIndex >= unrepliedMessages.length) {
            nextIndex = 0;
          }
        }

        const nextMessage = unrepliedMessages[nextIndex];
        if (nextMessage) {
          handleSelectMessage(nextMessage, nextIndex);
        }
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, [unrepliedMessages, selectedMessage]);

  // F2 (VIP Paket) ve F4 (Son mesajı sansürle) kısayolları
  useEffect(() => {
    const handleQuickActionKeys = (e) => {
      // Input veya textarea içindeysek F tuşlarını engellemeyelim ama bu sayfada F2/F4 global çalışmalı
      if (e.key === 'F2') {
        e.preventDefault();
        if (currentRoomId && currentSenderId) {
          handleSendOnetapVipPackage();
        }
      } else if (e.key === 'F4') {
        e.preventDefault();
        if (currentRoomId && currentSenderId && messages) {
          handleCensorLastUserMessage();
        }
      }
    };

    window.addEventListener('keydown', handleQuickActionKeys);
    return () => window.removeEventListener('keydown', handleQuickActionKeys);
  }, [currentRoomId, currentSenderId, messages, vipPackages]);

  // Seçili mesaj değiştiğinde verileri yükle
  useEffect(() => {
    if (selectedMessage && currentRoomId && currentSenderId && currentReceiverId) {
      loadData();
      loadMessages();
      loadRecordings();
      loadConversationNotes();
      // Yeni sohbet seçildiğinde resim durumlarını sıfırla
      setNewlySentImages(new Set());
      setExpandedImages(new Set());
      setShowAllImages(false); // Admin panel: Yeni sohbet seçildiğinde resimler kapalı moda dönmeli
      // Yeni sohbet seçildiğinde video durumlarını sıfırla
      setNewlySentVideos(new Set());
      setExpandedVideos(new Set());
      setShowAllVideos(false); // Admin panel: Yeni sohbet seçildiğinde videolar kapalı moda dönmeli

      // ✅ Yeni sohbet seçildiğinde giriş alanlarını sıfırla
      setMessageText("");
      setPastedImage(null);
      setPastedImagePreview(null);

      // Yeni sohbet seçildiğinde mesajlar yüklendikten sonra son mesaja scroll yap
      setTimeout(() => {
        const chatHistoryDiv = document.getElementById('chat-history');
        if (chatHistoryDiv) {
          chatHistoryDiv.scrollTop = chatHistoryDiv.scrollHeight;
        }
      }, 500);
    }
  }, [selectedMessage, currentRoomId, currentSenderId, currentReceiverId]);

  // Mesaj textarea'sına otomatik focus
  useEffect(() => {
    if (messageTextareaRef.current && currentRoomId) {
      setTimeout(() => messageTextareaRef.current?.focus(), 100);
    }
  }, [currentRoomId]);

  // Modal açıldığında input'a otomatik focus
  useEffect(() => {
    if (showCreditsModal && creditsInputRef.current) {
      setTimeout(() => creditsInputRef.current?.focus(), 100);
    }
  }, [showCreditsModal]);

  useEffect(() => {
    if (showPremiumModal && premiumInputRef.current) {
      setTimeout(() => premiumInputRef.current?.focus(), 100);
    }
  }, [showPremiumModal]);

  // Mesajları dinle (real-time)
  useEffect(() => {
    if (!currentRoomId) return;

    const messagesRef = collection(db, 'chatRooms', currentRoomId, 'messages');
    const q = query(messagesRef, orderBy('timestamp', 'asc'));

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const messagesList = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setMessages(messagesList);

      // Son sistem mesajını bul
      const systemMsgs = messagesList.filter(m => m.type === 'system' || m.senderId === 'system' || m.isSystemMessage);
      if (systemMsgs.length > 0) {
        setLastSystemMessage(systemMsgs[systemMsgs.length - 1].message);
      }

      // Yeni mesaj geldiğinde veya mesajlar yüklendiğinde son mesaja scroll yap
      setTimeout(() => {
        const chatHistoryDiv = document.getElementById('chat-history');
        if (chatHistoryDiv) {
          chatHistoryDiv.scrollTop = chatHistoryDiv.scrollHeight;
        }
      }, 300);
    });

    return () => unsubscribe();
  }, [currentRoomId]);

  // İlk yüklemede ve mesajlar yüklendiğinde son mesaja scroll yap
  useEffect(() => {
    if (messages.length > 0 && currentRoomId) {
      setTimeout(() => {
        const chatHistoryDiv = document.getElementById('chat-history');
        if (chatHistoryDiv) {
          chatHistoryDiv.scrollTop = chatHistoryDiv.scrollHeight;
        }
      }, 300);
    }
  }, [messages.length, currentRoomId]);


  const handleSendVipPhoneMessage = async () => {
    if (!vipPhoneMessage.trim() || !vipPhoneSelectedSku) return;

    try {
      setVipPhoneSending(true);
      setError(null);

      // find package type
      const selectedPkg = vipPackages.find(p => p.sku === vipPhoneSelectedSku);
      const packageType = selectedPkg?.type === 'Kredi' ? 'credits' : 'vip';

      const messagesRef = collection(db, 'chatRooms', currentRoomId, 'messages');
      const messageData = {
        senderId: 'system',
        receiverId: currentSenderId,
        message: vipPhoneMessage.trim(),
        timestamp: serverTimestamp(),
        type: 'system',
        sku: vipPhoneSelectedSku,
        packageType: packageType,
        isSystemMessage: true
      };

      await addDoc(messagesRef, messageData);

      const roomRef = doc(db, 'chatRooms', currentRoomId);
      await updateDoc(roomRef, {
        lastMessage: vipPhoneMessage.trim(),
        lastMessageAt: serverTimestamp(),
        lastMessageType: 'system'
      });

      setShowVipPhoneModal(false);
      alert('VIP-Telefon mesajı başarıyla gönderildi.');
    } catch (err) {
      console.error('Error sending VIP phone message:', err);
      setError('Mesaj gönderilemedi.');
    } finally {
      setVipPhoneSending(false);
    }
  };

  const handleSendOnetapVipPackage = async () => {
    try {
      if (!currentRoomId || !currentSenderId) return;
      setError(null);

      const messageText = "İçeriği görüntülemek için VIP Abone olmalısınız. VIP paketleri görüntülemek ve satın almak için tıklayınız.";

      const messagesRef = collection(db, 'chatRooms', currentRoomId, 'messages');
      const messageData = {
        senderId: 'system',
        receiverId: currentSenderId,
        message: messageText,
        timestamp: serverTimestamp(),
        type: 'system',
        sku: vipPackages.find(p => p.type !== 'Kredi')?.sku || vipPackages[0]?.sku || 'vip_package',
        packageType: 'vip',
        isSystemMessage: true
      };

      await addDoc(messagesRef, messageData);

      const roomRef = doc(db, 'chatRooms', currentRoomId);
      await updateDoc(roomRef, {
        lastMessage: messageText,
        lastMessageAt: serverTimestamp(),
        lastMessageType: 'system'
      });

    } catch (err) {
      console.error('Error sending One-tap VIP Package message:', err);
      setError('VIP Paket mesajı gönderilemedi.');
    }
  };

  const handleSendOnetapLocationPackage = async () => {
    try {
      if (!currentRoomId || !currentSenderId) return;
      setError(null);

      const messageText = "Konum bilgilerini görüntülemek için Konum Paketine sahip olmalısınız. Paketi görüntülemek ve satın almak için tıklayınız.";

      const messagesRef = collection(db, 'chatRooms', currentRoomId, 'messages');
      const messageData = {
        senderId: 'system',
        receiverId: currentSenderId,
        message: messageText,
        timestamp: serverTimestamp(),
        type: 'system',
        sku: vipPackages.find(p => p.type !== 'Kredi')?.sku || vipPackages[0]?.sku || 'vip_package',
        packageType: 'location',
        isSystemMessage: true
      };

      await addDoc(messagesRef, messageData);

      const roomRef = doc(db, 'chatRooms', currentRoomId);
      await updateDoc(roomRef, {
        lastMessage: messageText,
        lastMessageAt: serverTimestamp(),
        lastMessageType: 'system'
      });

    } catch (err) {
      console.error('Error sending One-tap Location Package message:', err);
      setError('Konum Paketi mesajı gönderilemedi.');
    }
  };

  const handleSendManualSystemMessage = async () => {
    if (!systemMessageText.trim()) return;

    try {
      setSending(true);
      setError(null);

      const messagesRef = collection(db, 'chatRooms', currentRoomId, 'messages');
      const messageData = {
        senderId: 'system',
        receiverId: currentSenderId,
        message: systemMessageText.trim(),
        timestamp: serverTimestamp(),
        type: 'system',
        isSystemMessage: true
      };

      await addDoc(messagesRef, messageData);

      const roomRef = doc(db, 'chatRooms', currentRoomId);
      await updateDoc(roomRef, {
        lastMessage: systemMessageText.trim(),
        lastMessageAt: serverTimestamp(),
        lastMessageType: 'system'
      });

      setShowSystemMessageModal(false);
      alert('Sistem mesajı başarıyla gönderildi.');
    } catch (err) {
      console.error('Error sending system message:', err);
      setError('Mesaj gönderilemedi.');
    } finally {
      setSending(false);
    }
  };

  const loadUnrepliedMessages = async () => {
    try {
      setLoading(true);
      setError(null);

      // ✅ UnrepliedMessages.js ile aynı kaynağı kullan: unansweredMessages collection
      // Functions tarafındaki onMessageCreated trigger'ı tarafından doldurulur
      const unansweredQuery = query(
        collection(db, 'unansweredMessages'),
        orderBy('createdAt', 'desc')
      );

      const unansweredSnapshot = await getDocs(unansweredQuery);
      console.log(`Total unanswered messages found: ${unansweredSnapshot.docs.length}`);

      // Aynı chatRoom için sadece en son mesajı tut
      const latestMessagesByRoom = new Map();

      unansweredSnapshot.docs.forEach(doc => {
        const data = doc.data();
        const roomId = data.chatRoomId;
        const timestamp = data.timestamp?.toDate ? data.timestamp.toDate() : new Date();

        // Eğer bu chatRoom için daha yeni bir mesaj yoksa ekle
        const existing = latestMessagesByRoom.get(roomId);
        if (!existing || timestamp > existing.date) {
          latestMessagesByRoom.set(roomId, {
            id: doc.id,
            roomId: roomId,
            sender: {
              id: data.senderId,
              name: data.senderName || 'Bilinmeyen',
              avatar: data.senderAvatar || null
            },
            receiver: {
              id: data.receiverId,
              name: data.receiverName || 'Bilinmeyen',
              avatar: data.receiverAvatar || null
            },
            message: data.message || (
              data.messageType === 'image' ? '📷 Fotoğraf' :
                data.messageType === 'video' ? '🎥 Video' :
                  data.messageType === 'audio' ? '🎤 Ses' : 'Mesaj'
            ),
            timestamp: data.timestamp,
            type: data.messageType || 'text',
            date: timestamp
          });
        }
      });

      // Map'i listeye çevir ve sırala
      const unrepliedList = Array.from(latestMessagesByRoom.values())
        .sort((a, b) => b.date.getTime() - a.date.getTime());

      setUnrepliedMessages(unrepliedList);
    } catch (err) {
      console.error('Error loading unreplied messages:', err);
      setError('Mesajlar yüklenirken bir hata oluştu.');
    } finally {
      setLoading(false);
    }
  };

  const handleSelectMessage = (message, index) => {
    setSelectedMessage(message);
    selectedIndexRef.current = index;
    setCurrentRoomId(message.roomId);
    setCurrentSenderId(message.sender.id);
    setCurrentReceiverId(message.receiver.id);

    // Scroll to selected item
    if (messageListRef.current) {
      const items = messageListRef.current.querySelectorAll('.message-item');
      if (items[index]) {
        items[index].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }
  };

  const handleDeleteMessage = async (msg) => {
    try {
      // unansweredMessages koleksiyonundan sil
      const unansweredQuery = query(
        collection(db, 'unansweredMessages'),
        where('chatRoomId', '==', msg.roomId)
      );
      const unansweredSnapshot = await getDocs(unansweredQuery);
      await Promise.all(unansweredSnapshot.docs.map(doc => deleteDoc(doc.ref)));

      // Sohbetteki tüm mesajları sil
      try {
        const messagesRef = collection(db, 'chatRooms', msg.roomId, 'messages');
        const messagesSnapshot = await getDocs(messagesRef);
        await Promise.all(messagesSnapshot.docs.map(doc => deleteDoc(doc.ref)));
        console.log(`Deleted ${messagesSnapshot.docs.length} messages from chatRoom ${msg.roomId}`);
      } catch (e) {
        console.warn('Error deleting chat messages:', e);
      }

      // Sohbet odasını sil
      try {
        await deleteDoc(doc(db, 'chatRooms', msg.roomId));
        console.log(`Deleted chatRoom ${msg.roomId}`);
      } catch (e) {
        console.warn('Error deleting chatRoom:', e);
      }

      // Listeden kaldır
      setUnrepliedMessages((prev) => prev.filter((m) => m.id !== msg.id));

      // Eğer silinen sohbet seçiliyse, seçimi temizle
      if (selectedMessage?.id === msg.id) {
        setSelectedMessage(null);
        setCurrentRoomId(null);
        setCurrentSenderId(null);
        setCurrentReceiverId(null);
      }
    } catch (err) {
      console.error('Error deleting message:', err);
      setError('Mesaj silinirken bir hata oluştu.');
    }
  };

  const handleIgnoreMessage = async (msg) => {
    try {
      // unansweredMessages koleksiyonundan sil (mesaj "Okundu" olarak işaretlenmiş sayılır)
      // Yeni mesaj gelince Cloud Function onMessageCreated tekrar ekleyecek
      const unansweredQuery = query(
        collection(db, 'unansweredMessages'),
        where('chatRoomId', '==', msg.roomId)
      );
      const unansweredSnapshot = await getDocs(unansweredQuery);
      await Promise.all(unansweredSnapshot.docs.map(doc => deleteDoc(doc.ref)));
      console.log(`Deleted ${unansweredSnapshot.docs.length} documents from unansweredMessages (marked as read)`);

      // Listeden kaldır
      setUnrepliedMessages((prev) => prev.filter((m) => m.id !== msg.id));

      // Eğer görmezden gelinen sohbet seçiliyse, seçimi temizle
      if (selectedMessage?.id === msg.id) {
        setSelectedMessage(null);
        setCurrentRoomId(null);
        setCurrentSenderId(null);
        setCurrentReceiverId(null);
      }
    } catch (err) {
      console.error('Error ignoring message:', err);
      setError('Mesaj görmezden gelinirken bir hata oluştu.');
    }
  };

  const loadData = async () => {
    if (!currentSenderId || !currentReceiverId) return;

    try {
      setLoading(true);

      const [senderDoc, receiverDoc] = await Promise.all([
        getDoc(doc(db, 'users', currentSenderId)),
        getDoc(doc(db, 'users', currentReceiverId))
      ]);

      const senderData = senderDoc.exists() ? senderDoc.data() : {};
      const receiverData = receiverDoc.exists() ? receiverDoc.data() : {};

      setUserInfo({
        id: currentSenderId,
        name: senderData.name || 'Bilinmeyen',
        email: senderData.email,
        phone: senderData.phone,
        city: senderData.city,
        age: senderData.age,
        profileImageUrl: senderData.profileImageUrl,
        credits: senderData.credits || 0,
        isPremium: senderData.isPremium || false,
        premiumExpiresAt: senderData.premiumExpiresAt,
        isBanned: senderData.isBanned || false,
        isTestUser: senderData.isTestUser || false,
        lastActive: senderData.lastActive
      });

      setTestUserInfo({
        id: currentReceiverId,
        name: receiverData.name || 'Bilinmeyen',
        email: receiverData.email,
        phone: receiverData.phone,
        city: receiverData.city,
        age: receiverData.age,
        profileImageUrl: receiverData.profileImageUrl,
        credits: receiverData.credits || 0,
        isPremium: receiverData.isPremium || false,
        premiumExpiresAt: receiverData.premiumExpiresAt,
        isTestUser: receiverData.isTestUser || false,
        lastActive: receiverData.lastActive
      });

      setUserCredits(senderData.credits || 0);
      setUserIsPremium(senderData.isPremium || false);
      setUserPremiumExpiresAt(senderData.premiumExpiresAt);
      setUserIsBanned(senderData.isBanned || false);
      setUserIsTestUser(senderData.isTestUser || false);

      setTestUserCredits(receiverData.credits || 0);
      setTestUserIsPremium(receiverData.isPremium || false);
      setTestUserPremiumExpiresAt(receiverData.premiumExpiresAt);
      const rIsTestUser = receiverData.isTestUser || false;
      const sIsTestUser = senderData.isTestUser || false;
      setTestUserIsTestUser(rIsTestUser);

      const realDataToCheck = rIsTestUser ? senderData : (sIsTestUser ? receiverData : null);
      const botIdToCheck = rIsTestUser ? currentReceiverId : (sIsTestUser ? currentSenderId : null);
      
      if (realDataToCheck && botIdToCheck) {
        const blockedList = realDataToCheck.blockedUsers || [];
        setIsBlockedByUser(blockedList.includes(botIdToCheck));
      } else {
        setIsBlockedByUser(false);
      }
    } catch (err) {
      console.error('Error loading data:', err);
      setError('Kullanıcı bilgileri yüklenirken bir hata oluştu.');
    } finally {
      setLoading(false);
    }
  };

  const loadMessages = async () => {
    if (!currentRoomId) return;

    try {
      const messagesRef = collection(db, 'chatRooms', currentRoomId, 'messages');
      const q = query(messagesRef, orderBy('timestamp', 'asc'));
      const snapshot = await getDocs(q);
      const messagesList = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setMessages(messagesList);

      // Mesajlar yüklendikten sonra son mesaja scroll yap
      setTimeout(() => {
        const chatHistoryDiv = document.getElementById('chat-history');
        if (chatHistoryDiv) {
          chatHistoryDiv.scrollTop = chatHistoryDiv.scrollHeight;
        }
      }, 200);
    } catch (err) {
      console.error('Error loading messages:', err);
    }
  };

  const loadQuickMessages = async () => {
    try {
      const currentUser = auth.currentUser;
      if (!currentUser) return;

      const quickMessagesRef = collection(db, 'users', currentUser.uid, 'quickMessages');
      const snapshot = await getDocs(quickMessagesRef);
      const messages = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      // Sıralama - küçükten büyüğe
      messages.sort((a, b) => {
        const orderA = a.order !== undefined ? Number(a.order) : 999;
        const orderB = b.order !== undefined ? Number(b.order) : 999;
        return orderA - orderB;
      });

      setQuickMessages(messages);
    } catch (err) {
      console.error('Error loading quick messages:', err);
    }
  };

  // Favorileri yükle
  const loadFavorites = async () => {
    try {
      const currentUser = auth.currentUser;
      if (!currentUser) return;

      const favoritesRef = collection(db, 'adminFavoriteChats');
      const q = query(favoritesRef, where('adminId', '==', currentUser.uid), orderBy('createdAt', 'desc'));
      const snapshot = await getDocs(q);
      const favorites = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setFavoriteChats(favorites);
      setFavoriteIds(new Set(favorites.map(f => f.chatRoomId)));
    } catch (err) {
      console.error('Error loading favorites:', err);
    }
  };

  // Favoriye ekle/çıkar
  const handleToggleFavorite = async (msg, e) => {
    e.stopPropagation();
    try {
      const currentUser = auth.currentUser;
      if (!currentUser) return;

      const chatRoomId = msg.roomId;
      const isFavorite = favoriteIds.has(chatRoomId);

      if (isFavorite) {
        // Favoriden çıkar
        const favoritesRef = collection(db, 'adminFavoriteChats');
        const q = query(favoritesRef,
          where('adminId', '==', currentUser.uid),
          where('chatRoomId', '==', chatRoomId)
        );
        const snapshot = await getDocs(q);
        snapshot.docs.forEach(async (docSnap) => {
          await deleteDoc(doc(db, 'adminFavoriteChats', docSnap.id));
        });

        // State güncelle
        const newFavoriteIds = new Set(favoriteIds);
        newFavoriteIds.delete(chatRoomId);
        setFavoriteIds(newFavoriteIds);
        setFavoriteChats(favoriteChats.filter(f => f.chatRoomId !== chatRoomId));
      } else {
        // Favoriye ekle
        const favoriteData = {
          adminId: currentUser.uid,
          chatRoomId: chatRoomId,
          senderId: msg.sender.id,
          senderName: msg.sender.name,
          senderAvatar: msg.sender.avatar,
          receiverId: msg.receiver.id,
          receiverName: msg.receiver.name,
          receiverAvatar: msg.receiver.avatar,
          lastMessage: msg.message,
          createdAt: serverTimestamp()
        };
        const docRef = await addDoc(collection(db, 'adminFavoriteChats'), favoriteData);

        // State güncelle
        const newFavoriteIds = new Set(favoriteIds);
        newFavoriteIds.add(chatRoomId);
        setFavoriteIds(newFavoriteIds);
        setFavoriteChats([{ id: docRef.id, ...favoriteData, chatRoomId }, ...favoriteChats]);
      }
    } catch (err) {
      console.error('Error toggling favorite:', err);
    }
  };

  // Admin tarafından cevaplanan son 30 mesajı yükle
  const loadRecentRepliedMessages = async () => {
    try {
      // Admin tarafından cevaplanan mesajları 'answeredMessages' koleksiyonundan çek
      const answeredRef = collection(db, 'answeredMessages');
      const q = query(answeredRef, orderBy('answeredAt', 'desc'), limit(30));
      const snapshot = await getDocs(q);

      const messages = snapshot.docs.map(docSnap => {
        const data = docSnap.data();
        return {
          id: docSnap.id,
          roomId: data.chatRoomId,
          sender: {
            id: data.senderId,
            name: data.senderName || 'Bilinmeyen',
            avatar: data.senderAvatar || null
          },
          receiver: {
            id: data.receiverId,
            name: data.receiverName || 'Bilinmeyen',
            avatar: data.receiverAvatar || null
          },
          message: data.message || data.lastMessage || 'Mesaj',
          timestamp: data.answeredAt || data.timestamp,
          date: data.answeredAt?.toDate ? data.answeredAt.toDate() : new Date()
        };
      });

      setRecentRepliedMessages(messages);
    } catch (err) {
      console.error('Error loading recent replied messages:', err);
    }
  };

  // Favorileri ve son mesajları yükle
  useEffect(() => {
    loadFavorites();
    loadRecentRepliedMessages();
  }, []);

  // Fake hesabın arşiv fotoğraflarını yükle
  const loadArchivePhotos = async (botUserId) => {
    if (!botUserId) return;

    try {
      const archiveRef = collection(db, 'users', botUserId, 'archivePhotos');
      const archiveSnapshot = await getDocs(archiveRef);
      const photos = archiveSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setArchivePhotos(photos);
    } catch (err) {
      console.error('Error loading archive photos:', err);
    }
  };

  // Fake hesaba yeni arşiv fotoğrafı yükle (Toplu yükleme destekli)
  const handleUploadArchivePhoto = async (files) => {
    const botId = testUserIsTestUser ? currentReceiverId : (userIsTestUser ? currentSenderId : null);
    if (!botId || !files || files.length === 0) return;

    try {
      setArchiveUploading(true);

      const uploadPromises = Array.from(files).map(async (file) => {
        // Storage'a yükle
        const timestamp = Date.now();
        const fileName = `archive_${timestamp}_${file.name}`;
        const r2Path = `archivePhotos/${botId}/${fileName}`;
        const downloadUrl = await uploadToR2(file, r2Path);

        // Firestore'a kaydet
        await addDoc(collection(db, 'users', botId, 'archivePhotos'), {
          url: downloadUrl,
          fileName: fileName,
          createdAt: serverTimestamp()
        });
      });

      await Promise.all(uploadPromises);

      // Listeyi güncelle
      await loadArchivePhotos(botId);
    } catch (err) {
      console.error('Error uploading archive photo:', err);
      setError('Fotoğraf yüklenirken hata oluştu: ' + err.message);
    } finally {
      setArchiveUploading(false);
    }
  };

  // Arşiv fotoğrafını sil
  const handleDeleteArchivePhoto = async (photoId) => {
    const botId = testUserIsTestUser ? currentReceiverId : (userIsTestUser ? currentSenderId : null);
    if (!botId || !photoId) return;

    try {
      await deleteDoc(doc(db, 'users', botId, 'archivePhotos', photoId));
      await loadArchivePhotos(botId);
    } catch (err) {
      console.error('Error deleting archive photo:', err);
    }
  };

  // Arşiv fotoğrafını mesaj olarak gönder
  const handleSendArchivePhoto = async (photoUrl) => {
    if (!photoUrl) return;

    setShowArchiveModal(false);
    await sendMessage('📷 Fotoğraf', 'image', photoUrl);
  };

  // Fake hesap değiştiğinde arşivi yükle
  useEffect(() => {
    const botId = testUserIsTestUser ? currentReceiverId : (userIsTestUser ? currentSenderId : null);
    if (botId) {
      loadArchivePhotos(botId);
      loadRecordings(botId);
    }
  }, [currentReceiverId, currentSenderId, testUserIsTestUser, userIsTestUser]);

  const loadRecordings = async (providedBotId = null) => {
    // Hangisi test kullanıcısı ise onun kayıtlarını yükle
    const botId = providedBotId || (testUserIsTestUser ? currentReceiverId : (userIsTestUser ? currentSenderId : null));
    if (!botId) return;

    try {
      const audioRef = collection(db, 'users', botId, 'audioRecordings');
      const audioSnapshot = await getDocs(audioRef);
      const audioList = audioSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setAudioRecordings(audioList);

      const videoRef = collection(db, 'users', botId, 'videoRecordings');
      const videoSnapshot = await getDocs(videoRef);
      const videoList = videoSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setVideoRecordings(videoList);
    } catch (err) {
      console.error('Error loading recordings:', err);
    }
  };

  const handleRecordingUpload = async (e) => {
    const file = e.target.files[0];
    const botId = testUserIsTestUser ? currentReceiverId : (userIsTestUser ? currentSenderId : null);
    if (!file || !botId) return;

    try {
      setUploading(true);
      const fileName = `${Date.now()}_${file.name}`;
      const type = recordingModalType; // 'audio' or 'video'

      // Storage rules reference isAdmin(), so this should work as long as admin claim is set
      const storagePath = `test_users/${botId}/${type}/${fileName}`;
      const downloadUrl = await uploadToR2(file, storagePath);

      const collectionName = type === 'audio' ? 'audioRecordings' : 'videoRecordings';
      const recordingsRef = collection(db, 'users', botId, collectionName);

      await addDoc(recordingsRef, {
        title: file.name,
        fileUrl: downloadUrl,
        type: type,
        createdAt: serverTimestamp()
      });

      await loadRecordings();
      alert('Kayıt başarıyla yüklendi.');
    } catch (err) {
      console.error('Error uploading recording:', err);
      alert('Yükleme sırasında bir hata oluştu: ' + err.message);
    } finally {
      setUploading(false);
    }
  };

  const handleDeleteRecording = async (recordingId) => {
    if (!window.confirm('Bu kaydı silmek istediğinize emin misiniz?')) return;

    const botId = testUserIsTestUser ? currentReceiverId : (userIsTestUser ? currentSenderId : null);
    if (!botId) return;

    try {
      const collectionName = recordingModalType === 'audio' ? 'audioRecordings' : 'videoRecordings';
      const recordingDocRef = doc(db, 'users', botId, collectionName, recordingId);
      await deleteDoc(recordingDocRef);
      await loadRecordings();
      alert('Kayıt silindi.');
    } catch (err) {
      console.error('Error deleting recording:', err);
      alert('Silme sırasında bir hata oluştu.');
    }
  };

  const loadConversationNotes = async () => {
    if (!currentRoomId) return;
    try {
      const notesRef = collection(db, 'chatRooms', currentRoomId, 'notes');
      const q = query(notesRef, orderBy('createdAt', 'desc'));
      const snapshot = await getDocs(q);
      const notesList = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setConversationNotes(notesList);
    } catch (err) {
      console.error('Error loading notes:', err);
    }
  };

  const handleAddManualNote = async () => {
    if (!noteContent.trim() || !currentRoomId) return;

    try {
      const notesRef = collection(db, 'chatRooms', currentRoomId, 'notes');
      await addDoc(notesRef, {
        type: noteType,
        content: noteContent.trim(),
        createdAt: serverTimestamp()
      });

      setNoteContent("");
      await loadConversationNotes();
    } catch (err) {
      console.error('Error adding note:', err);
      setError('Not eklenirken bir hata oluştu.');
    }
  };

  const handleDeleteConversationNote = async (noteId) => {
    if (!window.confirm('Bu notu silmek istediğinize emin misiniz?')) return;

    try {
      await deleteDoc(doc(db, 'chatRooms', currentRoomId, 'notes', noteId));
      await loadConversationNotes();
    } catch (err) {
      console.error('Error deleting note:', err);
      setError('Not silinirken bir hata oluştu.');
    }
  };

  const handleDeleteChatMessage = async (messageId) => {
    try {
      const messageRef = doc(db, 'chatRooms', currentRoomId, 'messages', messageId);
      await deleteDoc(messageRef);
      setMessages(messages.filter(msg => msg.id !== messageId));
    } catch (err) {
      console.error('Error deleting message:', err);
      alert('Mesaj silinirken bir hata oluştu.');
    }
  };

  const handleCensorChatMessage = async (messageId, messageText) => {
    try {
      const censoredText = '*'.repeat(messageText.length);
      const messageRef = doc(db, 'chatRooms', currentRoomId, 'messages', messageId);
      await updateDoc(messageRef, {
        message: censoredText
      });
      setMessages(messages.map(msg =>
        msg.id === messageId ? { ...msg, message: censoredText } : msg
      ));
    } catch (err) {
      console.error('Error censoring message:', err);
      alert('Mesaj sansürlenirken bir hata oluştu.');
    }
  };

  const handleCensorLastUserMessage = async () => {
    try {
      if (!currentRoomId || !currentSenderId || !messages || messages.length === 0) return;

      // Sadece gerçek kullanıcının (sender) attığı ve sistem/fake mesajı olmayanları bul
      const userMessages = messages.filter(m => m.senderId === currentSenderId && m.type !== 'system');
      if (userMessages.length === 0) {
        console.log("Sansürlenecek kullanıcı mesajı bulunamadı.");
        return;
      }

      // En sondakini al (mesajlar kronolojik sırada varsayılıyor)
      const lastUserMessage = userMessages[userMessages.length - 1];
      if (!lastUserMessage || !lastUserMessage.message) return;

      await handleCensorChatMessage(lastUserMessage.id, lastUserMessage.message);
      console.log(`F4: Son kullanıcı mesajı sansürlendi (${lastUserMessage.message})`);
    } catch (err) {
      console.error('Error censoring last user message:', err);
    }
  };

  const handleAddNoteFromChatMessage = async (message, senderId) => {
    try {
      if (!currentRoomId) return;
      const isFromApprovedProfile = senderId === currentReceiverId;
      const noteTypeToUse = isFromApprovedProfile ? 'bot' : 'member';

      let messageContent = '';
      if (typeof message === 'string') {
        messageContent = message;
      } else if (message && message.message) {
        messageContent = message.message;
      } else {
        messageContent = 'Mesaj içeriği yok';
      }

      const notesRef = collection(db, 'chatRooms', currentRoomId, 'notes');
      await addDoc(notesRef, {
        type: noteTypeToUse,
        content: messageContent,
        createdAt: serverTimestamp()
      });

      await loadConversationNotes();
    } catch (err) {
      console.error('Error adding note from message:', err);
      alert('Not eklenirken bir hata oluştu.');
    }
  };

  const loadAppSettings = async () => {
    try {
      const settingsDoc = await getDoc(doc(db, 'appSettings', 'premium'));
      if (settingsDoc.exists()) {
        setAppSettings(settingsDoc.data());
      }

      // Coin settings yükle
      const coinSettingsDoc = await getDoc(doc(db, 'appSettings', 'coinSettings'));
      if (coinSettingsDoc.exists()) {
        const data = coinSettingsDoc.data();
        setCoinSettings({
          messageCoin: data.messageCoin || 1,
          imageCoin: data.imageCoin || 20,
          videoCoin: data.videoCoin || 0,
          audioCoin: data.voiceCoin || 0,
          callCoin: data.callCoin || 150
        });
      }
    } catch (err) {
      console.error('Error loading app settings:', err);
    }
  };

  const sendMessage = async (text, type = 'text', mediaUrl = null) => {
    if (!text.trim() && !mediaUrl) return;

    if (isBlockedByUser) {
      setError('Bu hesap onayl� profili engelledi�i i�in i�lem yap�lamaz.');
      alert('Bu hesap sizi engelledi�i i�in mesaj g�nderilemez.');
      return;
    }

    try {
      setSending(true);
      setError(null);

      const currentUser = auth.currentUser;
      if (!currentUser) {
        setError('Admin kullanıcısı bulunamadı.');
        setSending(false);
        return;
      }

      // Admin panelden mesaj gönderirken jeton kontrolü yapılmaz
      // Admin panel özel yetkiye sahip olduğu için jeton kontrolü bypass edilir

      // Admin panelden gönderilen TÜM mesajlar onaylı profilden gitmeli
      // Onaylı profili (fake hesap) tespit et
      const botId = testUserIsTestUser ? currentReceiverId : (userIsTestUser ? currentSenderId : null);
      const realId = testUserIsTestUser ? currentSenderId : (userIsTestUser ? currentReceiverId : null);

      if (!botId || !realId) {
        setError('Bot hesabı veya hedef kullanıcı tespit edilemedi.');
        setSending(false);
        return;
      }

      const approvedProfileId = botId; // Onaylı profil gönderen
      const realUserId = realId; // Gerçek kullanıcı alıcı

      const messagesRef = collection(db, 'chatRooms', currentRoomId, 'messages');
      const messageData = {
        senderId: approvedProfileId, // Onaylı profil gönderen (admin her zaman onaylı profil adına mesaj gönderiyor)
        receiverId: realUserId, // Gerçek kullanıcı alıcı
        message: text || (type === 'image' ? '📷 Fotoğraf' : type === 'video' ? '🎥 Video' : type === 'audio' ? '🎤 Ses' : 'Mesaj'),
        timestamp: serverTimestamp(),
        type: type
      };
      if (mediaUrl) messageData.mediaUrl = mediaUrl;

      await addDoc(messagesRef, messageData);

      const roomRef = doc(db, 'chatRooms', currentRoomId);
      await updateDoc(roomRef, {
        participantUids: [approvedProfileId, realUserId],
        lastMessage: text || (type === 'image' ? '📷 Fotoğraf' : type === 'video' ? '🎥 Video' : type === 'audio' ? '🎤 Ses' : 'Mesaj'),
        lastMessageAt: serverTimestamp(),
        lastMessageType: type,
        ignoredAt: null
      });

      // unansweredMessages collection'ından bu chatRoom için dokümanı sil
      // (Cloud Function onMessageCreated trigger'ı da bunu yapıyor ama admin panelden gönderildiğinde manuel silmeliyiz)
      try {
        const unansweredQuery = query(
          collection(db, 'unansweredMessages'),
          where('chatRoomId', '==', currentRoomId)
        );
        const unansweredSnapshot = await getDocs(unansweredQuery);
        await Promise.all(unansweredSnapshot.docs.map(doc => deleteDoc(doc.ref)));
      } catch (err) {
        console.error('Error deleting from unansweredMessages:', err);
        // Hata olsa bile devam et
      }

      // answeredMessages koleksiyonuna kayıt ekle (Son Mesajlar tab'ı için)
      // ChatRoomId'yi döküman ID'si yaparak mükerrer kayıtları önlüyoruz
      try {
        await setDoc(doc(db, 'answeredMessages', currentRoomId), {
          chatRoomId: currentRoomId,
          senderId: realId,
          senderName: testUserIsTestUser ? testUserInfo?.name : userInfo?.name,
          senderAvatar: testUserIsTestUser ? (testUserInfo?.profileImageUrl || testUserInfo?.avatar) : (userInfo?.profileImageUrl || userInfo?.avatar),
          receiverId: botId,
          receiverName: testUserIsTestUser ? userInfo?.name : testUserInfo?.name,
          receiverAvatar: testUserIsTestUser ? (userInfo?.profileImageUrl || userInfo?.avatar) : (testUserInfo?.profileImageUrl || testUserInfo?.avatar),
          message: text || (type === 'image' ? '📷 Fotoğraf' : type === 'video' ? '🎥 Video' : type === 'audio' ? '🎤 Ses' : 'Mesaj'),
          answeredAt: serverTimestamp(),
          adminId: currentUser.uid
        });
      } catch (err) {
        console.error('Error adding to answeredMessages:', err);
        // Hata olsa bile devam et
      }

      if (type === 'text') setMessageText("");

      // Eğer resim gönderildiyse, yeni gönderilen resimler listesine ekle (ilk gönderimde gösterilsin)
      if (type === 'image' && mediaUrl) {
        // Mesaj gönderildikten sonra, yeni eklenen mesajı bul ve ID'sini al
        setTimeout(async () => {
          const messagesRef = collection(db, 'chatRooms', currentRoomId, 'messages');
          const q = query(messagesRef, orderBy('timestamp', 'desc'), limit(1));
          const snapshot = await getDocs(q);
          if (!snapshot.empty) {
            const newMsgId = snapshot.docs[0].id;
            setNewlySentImages(prev => new Set(prev).add(newMsgId));
            setExpandedImages(prev => new Set(prev).add(newMsgId)); // İlk gönderimde otomatik açık
          }
        }, 500);
      }

      // Eğer video gönderildiyse, yeni gönderilen videolar listesine ekle (ilk gönderimde gösterilsin)
      if (type === 'video' && mediaUrl) {
        // Mesaj gönderildikten sonra, yeni eklenen mesajı bul ve ID'sini al
        setTimeout(async () => {
          const messagesRef = collection(db, 'chatRooms', currentRoomId, 'messages');
          const q = query(messagesRef, orderBy('timestamp', 'desc'), limit(1));
          const snapshot = await getDocs(q);
          if (!snapshot.empty) {
            const newMsgId = snapshot.docs[0].id;
            setNewlySentVideos(prev => new Set(prev).add(newMsgId));
            setExpandedVideos(prev => new Set(prev).add(newMsgId)); // İlk gönderimde otomatik açık
          }
        }, 500);
      }

      // Mesaj gönderildikten sonra otomatik olarak son mesaja scroll yap
      setTimeout(() => {
        const chatHistoryDiv = document.getElementById('chat-history');
        if (chatHistoryDiv) {
          chatHistoryDiv.scrollTop = chatHistoryDiv.scrollHeight;
        }
      }, 300);

      // Real-time listener otomatik güncelleyecek, manuel yüklemeye gerek yok
    } catch (err) {
      console.error('Error sending message:', err);
      setError('Mesaj gönderilirken bir hata oluştu: ' + err.message);
    } finally {
      setSending(false);
    }
  };

  const handleSendTextMessage = async () => {
    // Eğer yapıştırılmış resim varsa önce onu gönder
    if (pastedImage) {
      const fileToSend = pastedImage;
      // State'leri temizle
      setPastedImage(null);
      setPastedImagePreview(null);
      // Resmi gönder
      await handleSendImage(fileToSend);
    }

    // Eğer metin de varsa onu gönder
    if (messageText.trim()) {
      await sendMessage(messageText.trim(), 'text');
    }
  };

  const handleSendImage = async (file) => {
    try {
      setSending(true);

      // Admin panelde premium kontrolü yapılmaz
      const fileName = `${Date.now()}_${file.name}`;
      const downloadUrl = await uploadToR2(file, `chat_media/${currentRoomId}/images/${fileName}`);
      await sendMessage("Fotoğraf gönderildi", 'image', downloadUrl);
    } catch (err) {
      console.error('Error sending image:', err);
      setError('Fotoğraf gönderilirken bir hata oluştu.');
    } finally {
      setSending(false);
    }
  };

  const handleSendAudio = async (file) => {
    try {
      setSending(true);

      // Admin panelde premium kontrolü yapılmaz
      const fileName = `${Date.now()}_${file.name}`;
      const downloadUrl = await uploadToR2(file, `chat_media/${currentRoomId}/audio/${fileName}`);
      await sendMessage("Ses kaydı gönderildi", 'audio', downloadUrl);
    } catch (err) {
      console.error('Error sending audio:', err);
      setError('Ses kaydı gönderilirken bir hata oluştu.');
    } finally {
      setSending(false);
    }
  };

  const handleSendNotification = async () => {
    if (!notificationTitle.trim() || !notificationMessage.trim() || !targetUserId) {
      alert("Lütfen başlık ve mesaj girin.");
      return;
    }

    try {
      setNotificationSending(true);
      const sendNotification = httpsCallable(functions, 'sendNotification');
      const result = await sendNotification({
        title: notificationTitle,
        message: notificationMessage,
        userIds: [targetUserId]
      });

      if (result.data.success) {
        alert("Bildirim başarıyla gönderildi.");
        setShowNotificationModal(false);
        setNotificationTitle("");
        setNotificationMessage("");
      } else {
        alert("Hata: " + (result.data.error || "Bilinmeyen hata"));
      }
    } catch (err) {
      console.error("Error sending notification:", err);
      alert("Bildirim gönderilirken bir hata oluştu: " + err.message);
    } finally {
      setNotificationSending(false);
    }
  };

  const handleSendVideo = async (file) => {
    try {
      setSending(true);

      // Admin panelde premium kontrolü yapılmaz
      const fileName = `${Date.now()}_${file.name}`;
      const downloadUrl = await uploadToR2(file, `chat_media/${currentRoomId}/videos/${fileName}`);
      await sendMessage("Video gönderildi", 'video', downloadUrl);
    } catch (err) {
      console.error('Error sending video:', err);
      setError('Video gönderilirken bir hata oluştu.');
    } finally {
      setSending(false);
    }
  };

  const handlePaste = (e) => {
    const items = e.clipboardData.items;
    for (let i = 0; i < items.length; i++) {
      if (items[i].type.indexOf("image") !== -1) {
        const file = items[i].getAsFile();
        if (file) {
          const reader = new FileReader();
          reader.onload = (event) => {
            setPastedImage(file);
            setPastedImagePreview(event.target.result);
          };
          reader.readAsDataURL(file);
        }
      }
    }
  };

  const handleUpdateCredits = async () => {
    if (!targetUserId) return;

    try {
      const creditsChange = parseInt(creditsInput);
      if (isNaN(creditsChange)) {
        setError('Geçerli bir jeton değeri girin.');
        return;
      }

      const userRef = doc(db, 'users', targetUserId);
      const userDoc = await getDoc(userRef);
      const currentCredits = userDoc.data()?.credits || 0;
      const newCredits = Math.max(0, currentCredits + creditsChange);

      await updateDoc(userRef, {
        credits: newCredits
      });

      if (targetUserId === currentSenderId) {
        setUserCredits(newCredits);
        if (userInfo) setUserInfo({ ...userInfo, credits: newCredits });
      } else {
        setTestUserCredits(newCredits);
        if (testUserInfo) setTestUserInfo({ ...testUserInfo, credits: newCredits });
      }

      setShowCreditsModal(false);
      setCreditsInput("");
      setTargetUserId(null);
    } catch (err) {
      console.error('Error updating credits:', err);
      setError('Jeton güncellenirken bir hata oluştu.');
    }
  };

  const handleSetDiamond = async () => {
    if (!currentSenderId) return;

    try {
      const userRef = doc(db, 'users', currentSenderId);
      await updateDoc(userRef, {
        isDiamond: true
      });

      setShowDiamondModal(false);
    } catch (err) {
      console.error('Error setting diamond:', err);
      setError('Diamond üye yapılırken bir hata oluştu.');
    }
  };

  const handleUpdatePremium = async () => {
    if (!targetUserId) return;

    try {
      const days = parseInt(premiumDaysInput);
      if (isNaN(days) || days < 0) {
        setError('Geçerli bir gün sayısı girin.');
        return;
      }

      const userRef = doc(db, 'users', targetUserId);
      let newExpiresAt = null;

      if (days > 0) {
        const now = new Date();
        const expiresAt = new Date(now.getTime() + days * 24 * 60 * 60 * 1000);
        newExpiresAt = Timestamp.fromDate(expiresAt);
      }

      await updateDoc(userRef, {
        isPremium: days > 0,
        premiumExpiresAt: newExpiresAt
      });

      if (targetUserId === currentSenderId) {
        setUserIsPremium(days > 0);
        setUserPremiumExpiresAt(newExpiresAt);
        if (userInfo) setUserInfo({ ...userInfo, isPremium: days > 0, premiumExpiresAt: newExpiresAt });
      } else {
        setTestUserIsPremium(days > 0);
        setTestUserPremiumExpiresAt(newExpiresAt);
        if (testUserInfo) setTestUserInfo({ ...testUserInfo, isPremium: days > 0, premiumExpiresAt: newExpiresAt });
      }

      setShowPremiumModal(false);
      setPremiumDaysInput("");
      setTargetUserId(null);
    } catch (err) {
      console.error('Error updating premium:', err);
      setError('Premium durumu güncellenirken bir hata oluştu.');
    }
  };

  const handleBanUser = async () => {
    try {
      const userRef = doc(db, 'users', currentSenderId);
      const userSnap = await getDoc(userRef);
      const userData = userSnap.data();

      await updateDoc(userRef, {
        isBanned: true
      });

      // Cihaz banı - deviceId varsa bannedDevices koleksiyonuna ekle
      const deviceId = userData?.deviceId;
      const hardwareId = userData?.hardwareId;
      if (deviceId) {
        const bannedDeviceRef = doc(db, 'bannedDevices', deviceId);
        await setDoc(bannedDeviceRef, {
          isBanned: true,
          bannedAt: serverTimestamp(),
          deviceId: deviceId,
          hardwareId: hardwareId || null,
          userId: currentSenderId,
          reason: 'Admin panelden banlandı (Hızlı Cevapsız)'
        });
        // hardwareId de varsa ayrıca onu da banla
        if (hardwareId) {
          await setDoc(doc(db, 'bannedDevices', hardwareId), {
            isBanned: true,
            bannedAt: serverTimestamp(),
            deviceId: hardwareId,
            hardwareId: hardwareId,
            linkedPrimaryId: deviceId,
            userId: currentSenderId,
            type: 'hardware_ban',
            reason: 'Admin panelden banlandı (Hızlı Cevapsız)'
          });
        }
        console.log(`Device banned: ${deviceId}, hardware: ${hardwareId} for user: ${currentSenderId}`);
      } else {
        console.warn(`No deviceId found for user ${currentSenderId}. User ban applied but device ban skipped.`);
      }

      setUserIsBanned(true);
      setShowBanModal(false);
      if (userInfo) {
        setUserInfo({ ...userInfo, isBanned: true });
      }
    } catch (err) {
      console.error('Error banning user:', err);
      setError('Kullanıcı banlanırken bir hata oluştu.');
    }
  };

  // Sadece cihaz banı - kullanıcı hesabını banlamadan sadece cihazı banla
  const handleDeviceBan = async () => {
    try {
      const userRef = doc(db, 'users', currentSenderId);
      const userSnap = await getDoc(userRef);
      const userData = userSnap.data();
      const deviceId = userData?.deviceId;
      const hardwareId = userData?.hardwareId;

      if (!deviceId) {
        alert('Bu kullanıcının cihaz bilgisi bulunamadı. Kullanıcı uygulamayı henüz açmamış olabilir.');
        return;
      }

      // deviceId'yi bannedDevices'a ekle
      await setDoc(doc(db, 'bannedDevices', deviceId), {
        isBanned: true,
        bannedAt: serverTimestamp(),
        deviceId: deviceId,
        hardwareId: hardwareId || null,
        userId: currentSenderId,
        reason: 'Cihaz banı (Hızlı Cevapsız)'
      });

      // hardwareId varsa onu da banla
      if (hardwareId) {
        await setDoc(doc(db, 'bannedDevices', hardwareId), {
          isBanned: true,
          bannedAt: serverTimestamp(),
          deviceId: hardwareId,
          hardwareId: hardwareId,
          linkedPrimaryId: deviceId,
          userId: currentSenderId,
          type: 'hardware_ban',
          reason: 'Cihaz banı (Hızlı Cevapsız)'
        });
      }

      // Kullanıcıyı da banla
      await updateDoc(userRef, { isBanned: true });

      setUserIsBanned(true);
      if (userInfo) {
        setUserInfo({ ...userInfo, isBanned: true });
      }

      alert(`Cihaz başarıyla banlandı!\nDevice ID: ${deviceId.substring(0, 16)}...\n${hardwareId ? 'Hardware ID: ' + hardwareId.substring(0, 16) + '...' : ''}\nBu cihaz artık uygulamayı açamaz, silip yüklese bile.`);
    } catch (err) {
      console.error('Error device banning user:', err);
      alert('Cihaz banı sırasında hata: ' + err.message);
    }
  };

  const handleStartCall = async () => {
    try {
      const currentUser = auth.currentUser;
      if (!currentUser) {
        setError('Admin kullanıcısı bulunamadı.');
        return;
      }

      let mediaUrl = null;

      if (callType === 'normal_voice') {
        // Normal arama - kayıt gerekmez
        mediaUrl = null;
      } else if (callType === 'recorded_voice') {
        if (audioRecordings.length === 0) {
          setError('Ses kaydı bulunamadı.');
          return;
        }
        const idx = Math.min(selectedRecordingIndex, audioRecordings.length - 1);
        mediaUrl = audioRecordings[idx].fileUrl;
      } else if (callType === 'recorded_video') {
        if (videoRecordings.length === 0) {
          setError('Video kaydı bulunamadı.');
          return;
        }
        const idx = Math.min(selectedRecordingIndex, videoRecordings.length - 1);
        mediaUrl = videoRecordings[idx].fileUrl;
      }

      const botId = testUserIsTestUser ? currentReceiverId : (userIsTestUser ? currentSenderId : null);
      const realId = testUserIsTestUser ? currentSenderId : (userIsTestUser ? currentReceiverId : null);

      if (!botId || !realId) {
        setError('Bot hesabı veya hedef kullanıcı tespit edilemedi.');
        return;
      }

      const callRequestsRef = collection(db, 'callRequests');
      const callRequestData = {
        callerId: botId, // Onaylı hesap arayan
        receiverId: realId, // Gerçek üye alıcı
        type: callType === 'recorded_video' ? 'video' : 'voice',
        mediaUrl: mediaUrl, // Varsa oynatılır
        status: 'ringing',
        createdAt: serverTimestamp()
      };

      await addDoc(callRequestsRef, callRequestData);
      setShowCallModal(false);
    } catch (err) {
      console.error('Error starting call:', err);
      setError('Arama başlatılırken bir hata oluştu: ' + err.message);
    }
  };

  const getTurkishLocative = (city) => {
    if (!city || city === '-') return '';
    const cleanCity = city.trim();
    if (!cleanCity) return '';
    const lastVowelMatch = cleanCity.match(/[aeıioöuü]/gi);
    const lastVowel = lastVowelMatch ? lastVowelMatch.pop().toLowerCase() : 'a';
    const lastChar = cleanCity.slice(-1).toLowerCase();
    const hardConsonants = 'fstkçşhp';
    const isHard = hardConsonants.includes(lastChar);
    let suffix = '';
    if ('aıou'.includes(lastVowel)) {
      suffix = isHard ? "'ta" : "'da";
    } else {
      suffix = isHard ? "'te" : "'de";
    }
    return cleanCity + suffix;
  };

  const replaceSmartVariables = (template) => {
    if (!template) return "";
    let processed = template;
    const variables = {
      'uye_sehir_da': getTurkishLocative(userInfo?.city),
      'uye_sehir': userInfo?.city || '',
      'onayli_yas': testUserInfo?.age || '',
      'uye_ad': userInfo?.name || '',
      'onayli_ad': testUserInfo?.name || ''
    };
    Object.keys(variables).forEach(key => {
      const regex = new RegExp(`{{${key}}}`, 'g');
      processed = processed.replace(regex, variables[key]);
    });
    return processed;
  };

  const handleSaveQuickMessage = async () => {
    try {
      const currentUser = auth.currentUser;
      if (!currentUser) return;

      if (!quickMessageTitle.trim() || !quickMessageContent.trim()) {
        setError('Başlık ve mesaj içeriği gereklidir.');
        return;
      }

      const quickMessagesRef = collection(db, 'users', currentUser.uid, 'quickMessages');

      if (editingQuickMessage) {
        const messageRef = doc(db, 'users', currentUser.uid, 'quickMessages', editingQuickMessage.id);
        await updateDoc(messageRef, {
          title: quickMessageTitle.trim(),
          content: quickMessageContent.trim(),
          isSmart: isSmart
        });
      } else {
        await addDoc(quickMessagesRef, {
          title: quickMessageTitle.trim(),
          content: quickMessageContent.trim(),
          isSmart: isSmart,
          createdAt: serverTimestamp()
        });
      }

      await loadQuickMessages();
      setShowQuickMessageModal(false);
      setQuickMessageTitle("");
      setQuickMessageContent("");
      setIsSmart(false);
      setEditingQuickMessage(null);
    } catch (err) {
      console.error('Error saving quick message:', err);
      setError('Hızlı mesaj kaydedilirken bir hata oluştu.');
    }
  };

  const handleUseQuickMessage = async (quickMsg) => {
    if (!quickMsg.content) return;

    let contentToUse = quickMsg.content;
    if (quickMsg.isSmart) {
      contentToUse = replaceSmartVariables(quickMsg.content);
    }

    setMessageText(contentToUse);
    setShowQuickMessageModal(false);

    try {
      await sendMessage(contentToUse, 'text');
    } catch (err) {
      console.error('Hızlı mesaj gönderilemedi:', err);
    }
  };

  const formatDate = (timestamp) => {
    if (!timestamp) return '';
    const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
    return date.toLocaleTimeString('tr-TR', {
      hour: '2-digit',
      minute: '2-digit',
      timeZone: 'Europe/Istanbul'
    });
  };

  const truncateMessage = (text, maxLength = 50) => {
    if (!text) return '';
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  };

  const canViewMedia = (messageType) => {
    // Admin panelde VIP kontrolü yapılmaz, tüm içerikler görüntülenebilir
    return true;
  };

  // Hediye havuzunu yükle (lazy, cached)
  const loadGiftsPool = async () => {
    if (gifts.length > 0) return;
    setGiftsLoading(true);
    try {
      const snap = await getDocs(query(collection(db, 'gifts')));
      const list = snap.docs
        .map(d => ({ id: d.id, ...d.data() }))
        .filter(g => g.isActive !== false)
        .sort((a, b) => a.name.localeCompare(b.name));
      setGifts(list);
    } catch (e) {
      console.error('Hediye yükleme hatası:', e);
    } finally {
      setGiftsLoading(false);
    }
  };

  // Hediye gönder: fake hesap → gerçek kullanıcı
  const handleSendGift = async (gift) => {
    if (!currentReceiverId || !currentSenderId) {
      alert('Önce bir sohbet seçin.');
      return;
    }
    setSendingGift(gift.id);
    const fakeUserId = currentReceiverId; // fake hesap
    const realUserId = currentSenderId;   // gerçek kullanıcı
    const fakeUserName = testUserInfo?.name || 'Pinki';
    const chatRoomId = currentRoomId; // Mevcut açık sohbet odası kullanılıyor (sort() yanlış ID üretiyordu)
    try {
      // Chat mesajı
      await addDoc(collection(db, 'chatRooms', chatRoomId, 'messages'), {
        senderId: fakeUserId,
        receiverId: realUserId,
        message: `${gift.name} hediye etti! 🎁`,
        timestamp: serverTimestamp(),
        type: 'gift',
        giftImageUrl: gift.imageUrl || null,
        giftName: gift.name
      });
      // ChatRoom son mesaj güncelle
      const roomRef = doc(db, 'chatRooms', chatRoomId);
      const roomSnap = await getDoc(roomRef);
      const existingUnread = roomSnap.exists() ? (roomSnap.data().unreadCounts || {}) : {};
      const newUnread = { ...existingUnread, [realUserId]: ((existingUnread[realUserId] || 0) + 1) };
      if (roomSnap.exists()) {
        await updateDoc(roomRef, {
          lastMessage: `${gift.name} 🎁`,
          lastMessageAt: serverTimestamp(),
          lastMessageType: 'gift',
          lastMessageSenderId: fakeUserId,
          unreadCounts: newUnread
        });
      } else {
        await setDoc(roomRef, {
          participantUids: [fakeUserId, realUserId],
          lastMessage: `${gift.name} 🎁`,
          lastMessageAt: serverTimestamp(),
          lastMessageType: 'gift',
          lastMessageSenderId: fakeUserId,
          unreadCounts: { [realUserId]: 1 }
        });
      }
      // Bildirim
      await addDoc(collection(db, 'notifications'), {
        userId: realUserId,
        senderId: fakeUserId,
        type: 'GIFT',
        title: 'Yeni Hediye!',
        body: `${fakeUserName} sana bir ${gift.name} gönderdi.`,
        imageUrl: gift.imageUrl || null,
        timestamp: serverTimestamp(),
        isRead: false
      });
      alert(`✅ ${gift.name} başarıyla gönderildi!`);
      setShowGiftModal(false);
    } catch (e) {
      console.error('Hediye gönderme hatası:', e);
      alert('Hediye gönderilemedi: ' + e.message);
    } finally {
      setSendingGift(null);
    }
  };

  return (
    <>
      <div className="py-4">
        <h4>Hızlı Cevapsız Mesajlar</h4>
        <small className="text-muted">Çift tırnak (") tuşu ile alttaki sohbete geçiş yapabilirsiniz</small>
      </div>

      {error && (
        <Alert variant="danger" className="mb-4" dismissible onClose={() => setError(null)}>
          {error}
        </Alert>
      )}

      <Row>
        {/* Sol Taraf: Cevapsız Mesajlar Listesi */}
        <Col md={3} className="mb-4">
          <Card className="border-0 shadow-sm" style={{ height: 'calc(100vh - 200px)', display: 'flex', flexDirection: 'column' }}>
            <Card.Body className="p-0 bg-dark text-white flex-grow-1 d-flex flex-column">
              {/* Tab Header */}
              <div className="d-flex border-bottom border-secondary">
                <button
                  className="btn flex-fill py-2 rounded-0 border-0"
                  style={{
                    backgroundColor: activeTab === 'sohbetler' ? '#17a2b8' : 'transparent',
                    color: activeTab === 'sohbetler' ? 'white' : '#adb5bd',
                    fontWeight: activeTab === 'sohbetler' ? 'bold' : 'normal'
                  }}
                  onClick={() => setActiveTab('sohbetler')}
                >
                  <FontAwesomeIcon icon={faComments} className="me-1" />
                  Sohbetler
                </button>
                <button
                  className="btn flex-fill py-2 rounded-0 border-0"
                  style={{
                    backgroundColor: activeTab === 'favoriler' ? '#17a2b8' : 'transparent',
                    color: activeTab === 'favoriler' ? 'white' : '#adb5bd',
                    fontWeight: activeTab === 'favoriler' ? 'bold' : 'normal'
                  }}
                  onClick={() => setActiveTab('favoriler')}
                >
                  <FontAwesomeIcon icon={faHeart} className="me-1" />
                  Favoriler
                </button>
                <button
                  className="btn flex-fill py-2 rounded-0 border-0"
                  style={{
                    backgroundColor: activeTab === 'sonMesajlar' ? '#17a2b8' : 'transparent',
                    color: activeTab === 'sonMesajlar' ? 'white' : '#adb5bd',
                    fontWeight: activeTab === 'sonMesajlar' ? 'bold' : 'normal'
                  }}
                  onClick={() => { setActiveTab('sonMesajlar'); loadRecentRepliedMessages(); }}
                >
                  <FontAwesomeIcon icon={faHistory} className="me-1" />
                  Son Mesajlar
                </button>
              </div>
              <div
                ref={messageListRef}
                className="list-group list-group-flush flex-grow-1 overflow-auto"
                style={{ maxHeight: 'calc(100vh - 280px)' }}
              >
                {/* Sohbetler Tab */}
                {activeTab === 'sohbetler' && (
                  <>
                    {loading && unrepliedMessages.length === 0 ? (
                      <div className="text-center py-5">
                        <FontAwesomeIcon icon={faSpinner} className="fa-spin fa-2x mb-3" />
                        <p className="text-muted">Yükleniyor...</p>
                      </div>
                    ) : unrepliedMessages.length === 0 ? (
                      <div className="text-center py-5">
                        <p className="text-muted">Cevapsız mesaj bulunamadı.</p>
                      </div>
                    ) : (
                      unrepliedMessages.map((msg, index) => (
                        <div
                          key={msg.id}
                          className="message-item list-group-item list-group-item-action text-white border-secondary cursor-pointer"
                          onClick={() => handleSelectMessage(msg, index)}
                          style={{
                            cursor: 'pointer',
                            backgroundColor: selectedMessage?.id === msg.id ? '#3498db' : '#2c3e50',
                            transition: 'background-color 0.2s ease'
                          }}
                        >
                          <div className="d-flex align-items-center">
                            <AvatarComponent
                              avatar={msg.sender.avatar}
                              name={msg.sender.name}
                              size={40}
                            />
                            <div className="flex-grow-1 ms-2">
                              <div className="d-flex justify-content-between align-items-center mb-1">
                                <strong className="flex-grow-1">{msg.sender.name} → {msg.receiver.name}</strong>
                                <div className="d-flex gap-1" onClick={(e) => e.stopPropagation()}>
                                  {/* Favori Butonu */}
                                  <Button
                                    variant="link"
                                    size="sm"
                                    onClick={(e) => handleToggleFavorite(msg, e)}
                                    style={{
                                      padding: '4px 8px',
                                      fontSize: '0.85rem',
                                      minWidth: '32px',
                                      height: '32px',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      border: 'none',
                                      color: favoriteIds.has(msg.roomId) ? '#f1c40f' : '#95a5a6'
                                    }}
                                    title={favoriteIds.has(msg.roomId) ? "Favoriden Çıkar" : "Favorilere Ekle"}
                                  >
                                    <FontAwesomeIcon icon={favoriteIds.has(msg.roomId) ? faHeart : faHeartRegular} />
                                  </Button>
                                  <Button
                                    variant="danger"
                                    size="sm"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleDeleteMessage(msg);
                                    }}
                                    style={{
                                      padding: '4px 8px',
                                      fontSize: '0.75rem',
                                      minWidth: '32px',
                                      height: '32px',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      border: 'none'
                                    }}
                                    title="Mesajı Cevapsız Mesajlardan Sil"
                                  >
                                    <FontAwesomeIcon icon={faTrash} />
                                  </Button>
                                  <Button
                                    variant="warning"
                                    size="sm"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleIgnoreMessage(msg);
                                    }}
                                    style={{
                                      padding: '4px 8px',
                                      fontSize: '0.75rem',
                                      minWidth: '32px',
                                      height: '32px',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      border: 'none'
                                    }}
                                    title="Mesajı Okundu Olarak İşaretle (Görmezden Gel)"
                                  >
                                    <FontAwesomeIcon icon={faEyeSlash} />
                                  </Button>
                                </div>
                              </div>
                              <small className="text-muted d-block">
                                {truncateMessage(msg.message)}
                              </small>
                            </div>
                          </div>
                        </div>
                      ))
                    )}
                  </>
                )}

                {/* Favoriler Tab */}
                {activeTab === 'favoriler' && (
                  <>
                    {favoriteChats.length === 0 ? (
                      <div className="text-center py-5">
                        <FontAwesomeIcon icon={faHeartRegular} className="fa-2x mb-3 text-muted" />
                        <p className="text-muted">Henüz favori sohbet yok.</p>
                      </div>
                    ) : (
                      favoriteChats.map((fav, index) => {
                        const msg = {
                          id: fav.id,
                          roomId: fav.chatRoomId,
                          sender: { id: fav.senderId, name: fav.senderName, avatar: fav.senderAvatar },
                          receiver: { id: fav.receiverId, name: fav.receiverName, avatar: fav.receiverAvatar },
                          message: fav.lastMessage || ''
                        };
                        return (
                          <div
                            key={fav.id}
                            className="message-item list-group-item list-group-item-action text-white border-secondary cursor-pointer"
                            onClick={() => handleSelectMessage(msg, index)}
                            style={{
                              cursor: 'pointer',
                              backgroundColor: selectedMessage?.id === fav.id ? '#3498db' : '#2c3e50',
                              transition: 'background-color 0.2s ease'
                            }}
                          >
                            <div className="d-flex align-items-center">
                              <AvatarComponent
                                avatar={fav.senderAvatar}
                                name={fav.senderName}
                                size={40}
                              />
                              <div className="flex-grow-1 ms-2">
                                <div className="d-flex justify-content-between align-items-center mb-1">
                                  <strong className="flex-grow-1">{fav.senderName} → {fav.receiverName}</strong>
                                  <Button
                                    variant="link"
                                    size="sm"
                                    onClick={(e) => handleToggleFavorite(msg, e)}
                                    style={{
                                      padding: '4px 8px',
                                      fontSize: '0.85rem',
                                      color: '#f1c40f'
                                    }}
                                    title="Favoriden Çıkar"
                                  >
                                    <FontAwesomeIcon icon={faHeart} />
                                  </Button>
                                </div>
                                <small className="text-muted d-block">
                                  {truncateMessage(fav.lastMessage)}
                                </small>
                              </div>
                            </div>
                          </div>
                        );
                      })
                    )}
                  </>
                )}

                {/* Son Mesajlar Tab */}
                {activeTab === 'sonMesajlar' && (
                  <>
                    {recentRepliedMessages.length === 0 ? (
                      <div className="text-center py-5">
                        <FontAwesomeIcon icon={faHistory} className="fa-2x mb-3 text-muted" />
                        <p className="text-muted">Henüz cevaplanan mesaj yok.</p>
                      </div>
                    ) : (
                      recentRepliedMessages.map((msg, index) => (
                        <div
                          key={msg.id}
                          className="message-item list-group-item list-group-item-action text-white border-secondary cursor-pointer"
                          onClick={() => handleSelectMessage(msg, index)}
                          style={{
                            cursor: 'pointer',
                            backgroundColor: selectedMessage?.id === msg.id ? '#3498db' : '#2c3e50',
                            transition: 'background-color 0.2s ease'
                          }}
                        >
                          <div className="d-flex align-items-center">
                            <AvatarComponent
                              avatar={msg.sender.avatar}
                              name={msg.sender.name}
                              size={40}
                            />
                            <div className="flex-grow-1 ms-2">
                              <div className="d-flex justify-content-between align-items-center mb-1">
                                <strong className="flex-grow-1">{msg.sender.name} → {msg.receiver.name}</strong>
                                <Button
                                  variant="link"
                                  size="sm"
                                  onClick={(e) => handleToggleFavorite(msg, e)}
                                  style={{
                                    padding: '4px 8px',
                                    fontSize: '0.85rem',
                                    color: favoriteIds.has(msg.roomId) ? '#f1c40f' : '#95a5a6'
                                  }}
                                  title={favoriteIds.has(msg.roomId) ? "Favoriden Çıkar" : "Favorilere Ekle"}
                                >
                                  <FontAwesomeIcon icon={favoriteIds.has(msg.roomId) ? faHeart : faHeartRegular} />
                                </Button>
                              </div>
                              <small className="text-muted d-block">
                                {truncateMessage(msg.message)}
                              </small>
                            </div>
                          </div>
                        </div>
                      ))
                    )}
                  </>
                )}
              </div>
            </Card.Body>
          </Card>
        </Col>

        {/* Orta ve Sağ Taraf: Mesaj Gönderme Ekranı */}
        {selectedMessage && userInfo && testUserInfo ? (
          <>
            {/* Orta: Sohbet Geçmişi ve Mesaj Yazma */}
            <Col md={6} className="mb-4">
              <Card className="border-0 shadow-sm" style={{ height: 'calc(100vh - 200px)', display: 'flex', flexDirection: 'column' }}>
                <Card.Header className="bg-white border-bottom">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                      {userInfo.profileImageUrl && (
                        <img
                          src={userInfo.profileImageUrl}
                          alt={userInfo.name}
                          className="rounded-circle me-2"
                          style={{ width: 28, height: 28, objectFit: 'cover' }}
                        />
                      )}
                      <strong>{userInfo.name}</strong>
                      <span className="mx-2">→</span>
                      {testUserInfo.profileImageUrl && (
                        <img
                          src={testUserInfo.profileImageUrl}
                          alt={testUserInfo.name}
                          className="rounded-circle me-2"
                          style={{ width: 28, height: 28, objectFit: 'cover' }}
                        />
                      )}
                      <strong>{testUserInfo.name}</strong>
                    </div>
                    <div className="d-flex gap-2">
                      <Button
                        variant="secondary"
                        size="sm"
                        onClick={handleSendOnetapVipPackage}
                      >
                        <FontAwesomeIcon icon={faCrown} className="me-1" />
                        VIP Paket
                      </Button>
                      <Button
                        variant="danger"
                        size="sm"
                        onClick={handleSendOnetapLocationPackage}
                      >
                        <FontAwesomeIcon icon={faCrown} className="me-1" />
                        Konum Paket
                      </Button>
                      <Button
                        variant="warning"
                        size="sm"
                        onClick={() => setShowVipPhoneModal(true)}
                      >
                        <FontAwesomeIcon icon={faCrown} className="me-1" />
                        VIP-Telefon
                      </Button>
                      <Button
                        variant="info"
                        size="sm"
                        onClick={() => {
                          setSystemMessageText(lastSystemMessage);
                          setShowSystemMessageModal(true);
                        }}
                      >
                        <FontAwesomeIcon icon={faPlus} className="me-1" />
                        Sistem Mesajı
                      </Button>
                    </div>
                  </div>
                </Card.Header>

                {/* Sohbet Geçmişi */}
                <Card.Body className="flex-grow-1 overflow-auto bg-light" id="chat-history">
                  {messages.length === 0 ? (
                    <div className="text-center py-4">
                      <p className="text-muted">Henüz mesaj yok.</p>
                    </div>
                  ) : (
                    <>
                      {/* Admin panel: Tüm resimleri göster/gizle butonu - sadece resim mesajları varsa göster */}
                      {messages.some(m => m.type === 'image' && canViewMedia(m.type)) && (
                        <div className="mb-3 d-flex justify-content-center">
                          <Button
                            variant={showAllImages ? "danger" : "primary"}
                            size="sm"
                            onClick={() => {
                              setShowAllImages(!showAllImages);
                              if (showAllImages) {
                                // Kapandığında yeni gönderilenlerin flag'lerini de temizle
                                setNewlySentImages(new Set());
                              }
                            }}
                          >
                            <FontAwesomeIcon icon={faImage} className="me-2" />
                            {showAllImages ? 'Resim Gizle' : 'Resim Göster'}
                          </Button>
                        </div>
                      )}
                      {/* Admin panel: Tüm videoları göster/gizle butonu - sadece video mesajları varsa göster */}
                      {messages.some(m => m.type === 'video' && canViewMedia(m.type)) && (
                        <div className="mb-3 d-flex justify-content-center">
                          <Button
                            variant={showAllVideos ? "danger" : "primary"}
                            size="sm"
                            onClick={() => {
                              setShowAllVideos(!showAllVideos);
                              if (showAllVideos) {
                                // Kapandığında yeni gönderilenlerin flag'lerini de temizle
                                setNewlySentVideos(new Set());
                              }
                            }}
                          >
                            <FontAwesomeIcon icon={faVideo} className="me-2" />
                            {showAllVideos ? 'Videoyu Gizle' : 'Videoyu Göster'}
                          </Button>
                        </div>
                      )}

                      {messages.map((msg, index) => {
                        const isFromTestUser = msg.senderId === currentReceiverId;
                        const canView = canViewMedia(msg.type);
                        const isFirstImage = msg.type === 'image' && index === messages.findIndex(m => m.type === 'image' && canViewMedia(m.type));
                        const isFirstVideo = msg.type === 'video' && index === messages.findIndex(m => m.type === 'video' && canViewMedia(m.type));

                        return (
                          <div key={msg.id} className={`mb-3 d-flex align-items-center ${isFromTestUser ? 'justify-content-end' : 'justify-content-start'}`}>
                            {!isFromTestUser && (
                              <div className="d-flex gap-2 me-2">
                                <Button
                                  variant="link"
                                  size="sm"
                                  className="p-0 text-muted"
                                  onClick={() => handleAddNoteFromChatMessage(msg, msg.senderId)}
                                  title="Nota Ekle"
                                >
                                  <FontAwesomeIcon icon={faStickyNote} size="xs" />
                                </Button>
                                <Button
                                  variant="link"
                                  size="sm"
                                  className="p-0 text-muted"
                                  onClick={() => {
                                    if (msg.type === 'text' && msg.message) {
                                      handleCensorChatMessage(msg.id, msg.message);
                                    } else {
                                      alert('Sadece metin mesajları sansürlenebilir.');
                                    }
                                  }}
                                  title="Sansürle"
                                >
                                  <FontAwesomeIcon icon={faExclamationTriangle} size="xs" />
                                </Button>
                                <Button
                                  variant="link"
                                  size="sm"
                                  className="p-0 text-danger"
                                  onClick={() => handleDeleteChatMessage(msg.id)}
                                  title="Mesajı Sil"
                                >
                                  <FontAwesomeIcon icon={faTrash} size="xs" />
                                </Button>
                              </div>
                            )}

                            <div className={`p-3 rounded ${isFromTestUser ? 'bg-primary text-white' : 'bg-white'}`} style={{ maxWidth: '70%' }}>
                              <div className="d-flex align-items-center mb-1">
                                <small className={isFromTestUser ? 'text-white-50' : 'text-muted'}>{formatDate(msg.timestamp)}</small>
                              </div>
                              {msg.type === 'text' && <div>{msg.message}</div>}
                              {msg.type === 'system' && (
                                <div style={{
                                  backgroundColor: '#fff3e0',
                                  padding: '10px',
                                  borderRadius: '12px',
                                  textAlign: 'center',
                                  width: '100%',
                                  border: '1px solid #ffe0b2',
                                  margin: '5px 0'
                                }}>
                                  <div className="d-flex align-items-center justify-content-center gap-2 mb-1">
                                    <FontAwesomeIcon icon={faStar} size="xs" style={{ color: '#ff9800' }} />
                                    <small style={{ fontWeight: 'bold', color: '#ff9800', fontSize: '0.75rem' }}>Sistem Mesajı</small>
                                    <FontAwesomeIcon icon={faStar} size="xs" style={{ color: '#ff9800' }} />
                                  </div>
                                  <div style={{ color: '#333', fontSize: '0.9rem' }}>{msg.message}</div>
                                </div>
                              )}
                              {msg.type === 'call_log' && (
                                <div className="d-flex align-items-center gap-2">
                                  {msg.message.toLowerCase().includes('sesli') ? (
                                    <FontAwesomeIcon icon={faPhone} className={isFromTestUser ? 'text-white-50' : 'text-muted'} />
                                  ) : (
                                    <FontAwesomeIcon icon={faVideo} className={isFromTestUser ? 'text-white-50' : 'text-muted'} />
                                  )}
                                  <div style={{ fontStyle: 'italic' }}>
                                    {msg.message}
                                  </div>
                                </div>
                              )}
                              {msg.type === 'image' && (
                                <div>
                                  {showAllImages || expandedImages.has(msg.id) || newlySentImages.has(msg.id) ? (
                                    <div>
                                      {/* Bireysel resim gizle butonu */}
                                      <div className="mb-2">
                                        <Button
                                          variant="danger"
                                          size="sm"
                                          onClick={() => {
                                            // Hem genel görünümü hem de bu resmin özel görünümünü kapat
                                            setShowAllImages(false);
                                            setNewlySentImages(new Set()); // Yeni gönderilen flag'ini temizle
                                            setExpandedImages(prev => {
                                              const newSet = new Set(prev);
                                              newSet.delete(msg.id);
                                              return newSet;
                                            });
                                          }}
                                        >
                                          <FontAwesomeIcon icon={faImage} className="me-2" />
                                          Resim Gizle
                                        </Button>
                                      </div>
                                      <img
                                        src={msg.mediaUrl}
                                        alt="Fotoğraf"
                                        style={{
                                          maxWidth: '150px',
                                          maxHeight: '150px',
                                          width: '150px',
                                          height: '150px',
                                          borderRadius: '8px',
                                          cursor: 'pointer',
                                          objectFit: 'cover',
                                          border: '2px solid #ddd'
                                        }}
                                      />
                                      <div className="mt-1">{msg.message}</div>
                                    </div>
                                  ) : (
                                    <div
                                      style={{
                                        padding: '8px 12px',
                                        backgroundColor: isFromTestUser ? 'rgba(255,255,255,0.2)' : '#e9ecef',
                                        borderRadius: '8px',
                                        cursor: 'pointer',
                                        display: 'inline-block'
                                      }}
                                      onClick={() => {
                                        setExpandedImages(prev => {
                                          const newSet = new Set(prev);
                                          newSet.add(msg.id);
                                          return newSet;
                                        });
                                      }}
                                    >
                                      <FontAwesomeIcon icon={faImage} className="me-2" />
                                      Resim Göster
                                    </div>
                                  )}
                                </div>
                              )}
                              {msg.type === 'video' && (
                                <div className="position-relative">
                                  {showAllVideos || expandedVideos.has(msg.id) || newlySentVideos.has(msg.id) ? (
                                    <div>
                                      {isFirstVideo && showAllVideos && (
                                        <div className="mb-2">
                                          <Button
                                            variant="danger"
                                            size="sm"
                                            onClick={() => {
                                              setShowAllVideos(false);
                                              setNewlySentVideos(new Set()); // Yeni gönderilen flag'ini temizle
                                            }}
                                          >
                                            <FontAwesomeIcon icon={faVideo} className="me-2" />
                                            Videoyu Gizle
                                          </Button>
                                        </div>
                                      )}
                                      <video
                                        src={msg.mediaUrl}
                                        controls
                                        style={{
                                          width: '150px',
                                          height: '150px',
                                          borderRadius: '8px',
                                          objectFit: 'cover',
                                          border: '2px solid #ddd'
                                        }}
                                      />
                                      <div className="mt-1">{msg.message}</div>
                                    </div>
                                  ) : (
                                    <div
                                      style={{
                                        padding: '8px 12px',
                                        backgroundColor: isFromTestUser ? 'rgba(255,255,255,0.2)' : '#e9ecef',
                                        borderRadius: '8px',
                                        cursor: 'pointer',
                                        display: 'inline-block'
                                      }}
                                      onClick={() => setShowAllVideos(true)}
                                    >
                                      <FontAwesomeIcon icon={faVideo} className="me-2" />
                                      Videoyu Göster
                                    </div>
                                  )}
                                </div>
                              )}
                              {msg.type === 'audio' && (
                                <div>
                                  <audio controls style={{ width: '100%' }} crossOrigin="anonymous" preload="metadata">
                                    <source src={msg.mediaUrl} type="audio/mp4" />
                                    <source src={msg.mediaUrl} type="audio/mpeg" />
                                    <source src={msg.mediaUrl} type="audio/m4a" />
                                  </audio>
                                  <div className="mt-1 d-flex align-items-center gap-2">
                                    {msg.message}
                                    <a href={msg.mediaUrl} target="_blank" rel="noopener noreferrer" className="text-primary small">
                                      ⬇ İndir
                                    </a>
                                  </div>
                                </div>
                              )}
                              {msg.type === 'gift' && (
                                <div
                                  style={{
                                    padding: '8px 12px',
                                    backgroundColor: isFromTestUser ? 'rgba(255,200,50,0.3)' : '#fff8e1',
                                    borderRadius: '8px',
                                    border: '1px solid #ffe082'
                                  }}
                                >
                                  <span style={{ fontSize: '1.1rem' }}>🎁</span>{' '}
                                  <strong>{msg.giftName || 'Hediye'}</strong> hediye etti.
                                </div>
                              )}
                            </div>

                            {isFromTestUser && (
                              <div className="d-flex gap-2 ms-2">
                                <Button
                                  variant="link"
                                  size="sm"
                                  className="p-0 text-muted"
                                  onClick={() => handleAddNoteFromChatMessage(msg, msg.senderId)}
                                  title="Nota Ekle"
                                >
                                  <FontAwesomeIcon icon={faStickyNote} size="xs" />
                                </Button>
                                <Button
                                  variant="link"
                                  size="sm"
                                  className="p-0 text-muted"
                                  onClick={() => {
                                    if (msg.type === 'text' && msg.message) {
                                      handleCensorChatMessage(msg.id, msg.message);
                                    } else {
                                      alert('Sadece metin mesajları sansürlenebilir.');
                                    }
                                  }}
                                  title="Sansürle"
                                >
                                  <FontAwesomeIcon icon={faExclamationTriangle} size="xs" />
                                </Button>
                                <Button
                                  variant="link"
                                  size="sm"
                                  className="p-0 text-danger"
                                  onClick={() => handleDeleteChatMessage(msg.id)}
                                  title="Mesajı Sil"
                                >
                                  <FontAwesomeIcon icon={faTrash} size="xs" />
                                </Button>
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </>
                  )}
                </Card.Body>

                {/* Mesaj Yazma */}
                <Card.Footer className="bg-white border-top">
                  {quickMessages.length > 0 && (
                    <div className="mb-3">
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <span className="text-muted small fw-bold">Hızlı Mesajlar Boyutu</span>
                        <Form.Range
                          min={0.5}
                          max={2.0}
                          step={0.1}
                          value={quickMessageScale}
                          onChange={(e) => setQuickMessageScale(parseFloat(e.target.value))}
                          style={{ width: '150px' }}
                        />
                        <span className="small text-muted">{Math.round(quickMessageScale * 100)}%</span>
                      </div>
                      <div
                        className="d-flex flex-wrap mb-2"
                        style={{
                          gap: `${0.5 * quickMessageScale}rem`,
                          marginBottom: '1rem'
                        }}
                      >
                        {quickMessages.map((msg) => (
                          <Badge
                            key={msg.id}
                            className="cursor-pointer"
                            onClick={() => handleUseQuickMessage(msg)}
                            style={{
                              cursor: 'pointer',
                              backgroundColor: msg.isSmart ? '#d4edda' : '#ffc107',
                              color: msg.isSmart ? '#155724' : '#000000',
                              fontWeight: 'bold',
                              fontSize: `${110 * quickMessageScale}%`,
                              padding: `${10 * quickMessageScale}px ${15 * quickMessageScale}px`,
                              textTransform: 'uppercase',
                              border: msg.isSmart ? '1px solid #28a745' : 'none'
                            }}
                          >
                            {msg.isSmart && <FontAwesomeIcon icon={faStar} className="me-1" />}
                            {msg.title}
                          </Badge>
                        ))}
                        <Badge
                          bg="success"
                          className="cursor-pointer"
                          onClick={() => {
                            setEditingQuickMessage(null);
                            setQuickMessageTitle("");
                            setQuickMessageContent("");
                            setIsSmart(false);
                            setShowQuickMessageModal(true);
                          }}
                          style={{
                            cursor: 'pointer',
                            fontSize: `${110 * quickMessageScale}%`,
                            padding: `${10 * quickMessageScale}px ${15 * quickMessageScale}px`
                          }}
                        >
                          <FontAwesomeIcon icon={faPlus} /> Yeni
                        </Badge>
                      </div>
                    </div>
                  )}

                  {pastedImagePreview && (
                    <div className="position-relative mb-2" style={{ width: 'fit-content' }}>
                      <img
                        src={pastedImagePreview}
                        alt="Pasted preview"
                        style={{ maxHeight: '150px', borderRadius: '8px', border: '1px solid #ddd' }}
                      />
                      <Button
                        variant="danger"
                        size="sm"
                        className="position-absolute top-0 end-0 rounded-circle p-0 d-flex align-items-center justify-content-center"
                        style={{ transform: 'translate(50%, -50%)', width: '24px', height: '24px' }}
                        onClick={() => {
                          setPastedImage(null);
                          setPastedImagePreview(null);
                        }}
                      >
                        <FontAwesomeIcon icon={faTimes} style={{ fontSize: '10px' }} />
                      </Button>
                    </div>
                  )}

                  <Form.Group className="mb-3">
                    <Form.Control
                      ref={messageTextareaRef}
                      as="textarea"
                      rows={3}
                      placeholder={isBlockedByUser ? "Bu hesap sizi engelledi�i i�in mesaj yazamazs�n�z." : "Mesaj Yaz"}
                      value={messageText}
                      onChange={(e) => setMessageText(e.target.value)}
                      onPaste={handlePaste}
                      disabled={isBlockedByUser}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter' && !e.shiftKey) {
                          e.preventDefault();
                          if (!isBlockedByUser) handleSendTextMessage();
                        }
                      }}
                      autoFocus={!isBlockedByUser}
                    />
                  </Form.Group>

                  <div className="d-flex gap-2 mb-3">
                    <InputGroup>
                      <Form.Control
                        type="file"
                        accept="image/*"
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (file) handleSendImage(file);
                        }}
                        style={{ display: 'none' }}
                        id="imageInput"
                      />
                      <Button
                        variant="outline-primary"
                        size="sm"
                        onClick={() => document.getElementById('imageInput').click()}
                        disabled={sending}
                      >
                        <FontAwesomeIcon icon={faImage} />
                      </Button>
                    </InputGroup>

                    <InputGroup>
                      <Form.Control
                        type="file"
                        accept="audio/*"
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (file) handleSendAudio(file);
                        }}
                        style={{ display: 'none' }}
                        id="audioInput"
                      />
                      <Button
                        variant="outline-primary"
                        size="sm"
                        onClick={() => document.getElementById('audioInput').click()}
                        disabled={sending}
                      >
                        <FontAwesomeIcon icon={faFileAudio} />
                      </Button>
                    </InputGroup>

                    <InputGroup>
                      <Form.Control
                        type="file"
                        accept="video/*"
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (file) handleSendVideo(file);
                        }}
                        style={{ display: 'none' }}
                        id="videoInput"
                      />
                      <Button
                        variant="outline-primary"
                        size="sm"
                        onClick={() => document.getElementById('videoInput').click()}
                        disabled={sending}
                      >
                        <FontAwesomeIcon icon={faVideo} />
                      </Button>
                    </InputGroup>

                    <Button
                      variant="info"
                      onClick={handleSendTextMessage}
                      disabled={(!messageText.trim() && !pastedImage) || sending}
                    >
                      {sending ? (
                        <>
                          <FontAwesomeIcon icon={faSpinner} className="fa-spin me-2" />
                          Gönderiliyor...
                        </>
                      ) : (
                        'Gönder'
                      )}
                    </Button>
                  </div>
                </Card.Footer>
              </Card >
            </Col >

            {/* Sağ Taraf: Kullanıcı Bilgileri */}
            < Col md={3} className="mb-4" >
              <Row>
                {/* Fake Hesap (Doğrulanmış Profil) */}
                <Col md={12} className="mb-3">
                  <Card className="border-0 shadow-sm">
                    <Card.Body>
                      {testUserInfo.profileImageUrl && (
                        <div className="text-center mb-3">
                          <div style={{
                            display: 'inline-block',
                            padding: testUserIsPremium ? '3px' : '0',
                            borderRadius: '50%',
                            background: testUserIsPremium ? 'linear-gradient(135deg, #f1c40f, #f39c12)' : 'transparent'
                          }}>
                            <img
                              src={testUserInfo.profileImageUrl}
                              alt={testUserInfo.name}
                              className="rounded-circle"
                              style={{
                                width: 60,
                                height: 60,
                                objectFit: 'cover',
                                border: testUserIsPremium ? '2px solid white' : 'none'
                              }}
                            />
                          </div>
                        </div>
                      )}

                      <Table className="table-sm mb-3" borderless>
                        <tbody>
                          <tr>
                            <td style={{ width: '30px' }}><FontAwesomeIcon icon={faUser} style={{ color: '#6c757d' }} /></td>
                            <td>{testUserInfo.name}</td>
                          </tr>
                          <tr>
                            <td><FontAwesomeIcon icon={faMapMarkerAlt} style={{ color: '#e74c3c' }} /></td>
                            <td>{testUserInfo.city || '-'}</td>
                          </tr>
                          <tr>
                            <td><FontAwesomeIcon icon={faBirthdayCake} style={{ color: '#f39c12' }} /></td>
                            <td>{testUserInfo.age || '-'}</td>
                          </tr>
                          <tr>
                            <td><FontAwesomeIcon icon={faCoins} style={{ color: '#f1c40f' }} /></td>
                            <td>{testUserCredits}</td>
                          </tr>
                          <tr>
                            <td><FontAwesomeIcon icon={faClock} style={{ color: '#3498db' }} /></td>
                            <td>{testUserInfo.lastActive ? (testUserInfo.lastActive.toDate ? testUserInfo.lastActive.toDate().toLocaleString('tr-TR') : new Date(testUserInfo.lastActive).toLocaleString('tr-TR')) : 'Bilinmiyor'}</td>
                          </tr>
                          <tr>
                            <td><FontAwesomeIcon icon={faCrown} style={{ color: '#f1c40f' }} /></td>
                            <td>
                              {testUserIsPremium ? (
                                <>
                                  {testUserPremiumExpiresAt ?
                                    `${testUserPremiumExpiresAt.toDate ? testUserPremiumExpiresAt.toDate().toLocaleDateString('tr-TR') : new Date(testUserPremiumExpiresAt).toLocaleDateString('tr-TR')}` :
                                    'Aktif'}
                                </>
                              ) : (
                                'Hayır'
                              )}
                            </td>
                          </tr>
                        </tbody>
                      </Table>

                      <div className="d-flex flex-wrap gap-2 justify-content-center border-top pt-3">
                        <OverlayTrigger overlay={<Tooltip>Jeton Ekle/Sil</Tooltip>}>
                          <Button
                            variant="outline-success"
                            size="sm"
                            style={{ width: '38px', height: '38px', padding: 0 }}
                            onClick={() => {
                              setCreditsInput("");
                              setTargetUserId(currentReceiverId);
                              setShowCreditsModal(true);
                            }}
                          >
                            <FontAwesomeIcon icon={faDollarSign} />
                          </Button>
                        </OverlayTrigger>

                        <OverlayTrigger overlay={<Tooltip>Premium Ekle</Tooltip>}>
                          <Button
                            variant="outline-warning"
                            size="sm"
                            style={{ width: '38px', height: '38px', padding: 0 }}
                            onClick={() => {
                              setPremiumDaysInput("");
                              setTargetUserId(currentReceiverId);
                              setShowPremiumModal(true);
                            }}
                          >
                            <FontAwesomeIcon icon={faCrown} />
                          </Button>
                        </OverlayTrigger>

                        <OverlayTrigger overlay={<Tooltip>Bildirim Gönder</Tooltip>}>
                          <Button
                            variant="outline-info"
                            size="sm"
                            style={{ width: '38px', height: '38px', padding: '4px' }}
                            onClick={() => {
                              setTargetUserId(currentReceiverId);
                              setShowNotificationModal(true);
                            }}
                          >
                            <FontAwesomeIcon icon={faBell} />
                          </Button>
                        </OverlayTrigger>

                        <OverlayTrigger overlay={<Tooltip>Hediye Gönder</Tooltip>}>
                          <Button
                            variant="outline-warning"
                            size="sm"
                            style={{ width: '38px', height: '38px', padding: '4px' }}
                            onClick={() => {
                              loadGiftsPool();
                              setShowGiftModal(true);
                            }}
                          >
                            <FontAwesomeIcon icon={faGift} />
                          </Button>
                        </OverlayTrigger>

                        {testUserIsTestUser && (
                          <>
                            <OverlayTrigger overlay={<Tooltip>Ses Kayıtları ({audioRecordings.length})</Tooltip>}>
                              <Button
                                variant="outline-primary"
                                size="sm"
                                style={{ width: '38px', height: '38px', padding: 0 }}
                                onClick={() => {
                                  setRecordingModalType('audio');
                                  setShowRecordingModal(true);
                                }}
                              >
                                <FontAwesomeIcon icon={faFileAudio} />
                              </Button>
                            </OverlayTrigger>

                            <OverlayTrigger overlay={<Tooltip>Video Kayıtları ({videoRecordings.length})</Tooltip>}>
                              <Button
                                variant="outline-primary"
                                size="sm"
                                style={{ width: '38px', height: '38px', padding: 0 }}
                                onClick={() => {
                                  setRecordingModalType('video');
                                  setShowRecordingModal(true);
                                }}
                              >
                                <FontAwesomeIcon icon={faVideo} />
                              </Button>
                            </OverlayTrigger>

                            <OverlayTrigger overlay={<Tooltip>Fotoğraf Arşivi ({archivePhotos.length})</Tooltip>}>
                              <Button
                                variant="outline-secondary"
                                size="sm"
                                style={{ width: '38px', height: '38px', padding: '4px', position: 'relative' }}
                                onClick={() => setShowArchiveModal(true)}
                              >
                                <FontAwesomeIcon icon={faImages} />
                                {archivePhotos.length > 0 && (
                                  <Badge
                                    bg="danger"
                                    pill
                                    style={{
                                      position: 'absolute',
                                      top: '-5px',
                                      right: '-5px',
                                      fontSize: '0.6rem',
                                      padding: '3px 5px'
                                    }}
                                  >
                                    +{archivePhotos.length}
                                  </Badge>
                                )}
                              </Button>
                            </OverlayTrigger>
                          </>
                        )}
                      </div>
                    </Card.Body>
                  </Card>
                </Col>

                {/* Gerçek Üye */}
                <Col md={12}>
                  <Card className="border-0 shadow-sm">
                    <Card.Body>
                      {userInfo.profileImageUrl && (
                        <div className="text-center mb-3">
                          <div style={{
                            display: 'inline-block',
                            position: 'relative',
                            padding: userIsPremium ? '3px' : '0',
                            borderRadius: '50%',
                            background: userIsPremium ? 'linear-gradient(135deg, #f1c40f, #f39c12)' : 'transparent'
                          }}>
                            <img
                              src={userInfo.profileImageUrl}
                              alt={userInfo.name}
                              className="rounded-circle"
                              style={{
                                width: 60,
                                height: 60,
                                objectFit: 'cover',
                                border: userIsPremium ? '2px solid white' : 'none'
                              }}
                            />
                            {userInfo.name && userInfo.name !== 'Sansürlü' && (
                              <Button
                                variant="danger"
                                size="sm"
                                className="rounded-circle shadow-sm"
                                style={{
                                  position: 'absolute',
                                  bottom: '0px',
                                  right: '-5px',
                                  width: '24px',
                                  height: '24px',
                                  padding: 0,
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  zIndex: 10
                                }}
                                title="Fotoğrafı Sansürle (Avatar Yap)"
                                onClick={async () => {
                                  if (window.confirm("Profil fotoğrafını sansürlemek (avatar yapmak) istediğinize emin misiniz?")) {
                                    try {
                                      const defaultAvatar = '/default_avatar.png';
                                      await updateDoc(doc(db, 'users', currentSenderId), {
                                        profileImageUrl: defaultAvatar,
                                        avatar: defaultAvatar
                                      });
                                      setUserInfo({ ...userInfo, profileImageUrl: defaultAvatar, avatar: defaultAvatar });
                                    } catch (e) { console.error('Error censoring photo:', e); }
                                  }
                                }}
                              >
                                <FontAwesomeIcon icon={faEyeSlash} style={{ fontSize: '10px' }} />
                              </Button>
                            )}
                          </div>
                        </div>
                      )}

                      <Table className="table-sm mb-3" borderless>
                        <tbody>
                          <tr>
                            <td style={{ width: '30px' }}><FontAwesomeIcon icon={faUser} style={{ color: '#6c757d' }} /></td>
                            <td>
                              {userInfo.name}
                              {userInfo.name && !userInfo.name.includes('*') && (
                                <Button
                                  variant="link"
                                  size="sm"
                                  className="p-0 ms-2 text-danger"
                                  title="İsmi Sansürle"
                                  onClick={async () => {
                                    if (window.confirm("Kullanıcının ismini sansürlemek istediğinize emin misiniz?")) {
                                      try {
                                        const censoredName = '*'.repeat(userInfo.name.length || 5);
                                        await updateDoc(doc(db, 'users', currentSenderId), { name: censoredName });
                                        setUserInfo({ ...userInfo, name: censoredName });
                                      } catch (e) { console.error('Error censoring name:', e); }
                                    }
                                  }}
                                >
                                  <FontAwesomeIcon icon={faEyeSlash} />
                                </Button>
                              )}
                            </td>
                          </tr>
                          <tr>
                            <td><FontAwesomeIcon icon={faMapMarkerAlt} style={{ color: '#e74c3c' }} /></td>
                            <td>{userInfo.city || '-'}</td>
                          </tr>
                          <tr>
                            <td><FontAwesomeIcon icon={faBirthdayCake} style={{ color: '#f39c12' }} /></td>
                            <td>{userInfo.age || '-'}</td>
                          </tr>
                          <tr>
                            <td><FontAwesomeIcon icon={faCoins} style={{ color: '#f1c40f' }} /></td>
                            <td>{userCredits}</td>
                          </tr>
                          <tr>
                            <td><FontAwesomeIcon icon={faClock} style={{ color: '#3498db' }} /></td>
                            <td>{userInfo.lastActive ? (userInfo.lastActive.toDate ? userInfo.lastActive.toDate().toLocaleString('tr-TR') : new Date(userInfo.lastActive).toLocaleString('tr-TR')) : 'Bilinmiyor'}</td>
                          </tr>
                          <tr>
                            <td><FontAwesomeIcon icon={faCrown} style={{ color: '#f1c40f' }} /></td>
                            <td>
                              {userIsPremium ? (
                                <>
                                  {userPremiumExpiresAt ?
                                    `${userPremiumExpiresAt.toDate ? userPremiumExpiresAt.toDate().toLocaleDateString('tr-TR') : new Date(userPremiumExpiresAt).toLocaleDateString('tr-TR')}` :
                                    'Aktif'}
                                </>
                              ) : (
                                'Hayır'
                              )}
                            </td>
                          </tr>
                          <tr>
                            <td><FontAwesomeIcon icon={faEnvelope} style={{ color: '#9b59b6' }} /></td>
                            <td>{userInfo.email || '-'}</td>
                          </tr>
                        </tbody>
                      </Table>

                      <div className="d-flex flex-wrap gap-2 justify-content-center border-top pt-3">
                        <OverlayTrigger overlay={<Tooltip>Jeton Ekle/Sil</Tooltip>}>
                          <Button
                            variant="outline-success"
                            size="sm"
                            style={{ width: '38px', height: '38px', padding: 0 }}
                            onClick={() => {
                              setCreditsInput("");
                              setTargetUserId(currentSenderId);
                              setShowCreditsModal(true);
                            }}
                          >
                            <FontAwesomeIcon icon={faDollarSign} />
                          </Button>
                        </OverlayTrigger>

                        <OverlayTrigger overlay={<Tooltip>Premium Ekle</Tooltip>}>
                          <Button
                            variant="outline-warning"
                            size="sm"
                            style={{ width: '38px', height: '38px', padding: 0 }}
                            onClick={() => {
                              setPremiumDaysInput("");
                              setTargetUserId(currentSenderId);
                              setShowPremiumModal(true);
                            }}
                          >
                            <FontAwesomeIcon icon={faCrown} />
                          </Button>
                        </OverlayTrigger>

                        {!userIsTestUser && (
                          <OverlayTrigger overlay={<Tooltip>Arama Başlat</Tooltip>}>
                            <Button
                              variant="outline-primary"
                              size="sm"
                              style={{ width: '38px', height: '38px', padding: 0 }}
                              onClick={() => setShowCallModal(true)}
                            >
                              <FontAwesomeIcon icon={faPhone} />
                            </Button>
                          </OverlayTrigger>
                        )}

                        {!userIsTestUser && (
                          <OverlayTrigger overlay={<Tooltip>Diamond Üye Yap</Tooltip>}>
                            <Button
                              variant="outline-info"
                              size="sm"
                              style={{ width: '38px', height: '38px', padding: 0 }}
                              onClick={() => setShowDiamondModal(true)}
                            >
                              <FontAwesomeIcon icon={faGem} />
                            </Button>
                          </OverlayTrigger>
                        )}

                        <OverlayTrigger overlay={<Tooltip>{userIsBanned ? 'Banı Kaldır' : 'Banla'}</Tooltip>}>
                          <Button
                            variant="outline-danger"
                            size="sm"
                            style={{ width: '38px', height: '38px', padding: 0 }}
                            onClick={() => setShowBanModal(true)}
                          >
                            <FontAwesomeIcon icon={faBan} />
                          </Button>
                        </OverlayTrigger>

                        <OverlayTrigger overlay={<Tooltip>Cihaz Banla (Kalıcı)</Tooltip>}>
                          <Button
                            variant="danger"
                            size="sm"
                            style={{ width: '38px', height: '38px', padding: 0 }}
                            onClick={() => {
                              if (window.confirm('Bu kullanıcının CİHAZINI banlamak istediğinize emin misiniz?\n\nBu işlem:\n• Cihazı kalıcı olarak banlar\n• Uygulama silip yüklese bile ban devam eder\n• Yeni hesap açsa bile giriş yapamaz')) {
                                handleDeviceBan();
                              }
                            }}
                          >
                            <FontAwesomeIcon icon={faMobileAlt} />
                          </Button>
                        </OverlayTrigger>

                        <OverlayTrigger overlay={<Tooltip>Bildirim Gönder</Tooltip>}>
                          <Button
                            variant="outline-info"
                            size="sm"
                            style={{ width: '38px', height: '38px', padding: '4px' }}
                            onClick={() => {
                              setTargetUserId(currentSenderId);
                              setShowNotificationModal(true);
                            }}
                          >
                            <FontAwesomeIcon icon={faBell} />
                          </Button>
                        </OverlayTrigger>

                        {userIsTestUser && (
                          <>
                            <OverlayTrigger overlay={<Tooltip>Ses Kayıtları ({audioRecordings.length})</Tooltip>}>
                              <Button
                                variant="outline-primary"
                                size="sm"
                                style={{ width: '38px', height: '38px', padding: 0 }}
                                onClick={() => {
                                  setRecordingModalType('audio');
                                  setShowRecordingModal(true);
                                }}
                              >
                                <FontAwesomeIcon icon={faFileAudio} />
                              </Button>
                            </OverlayTrigger>

                            <OverlayTrigger overlay={<Tooltip>Video Kayıtları ({videoRecordings.length})</Tooltip>}>
                              <Button
                                variant="outline-primary"
                                size="sm"
                                style={{ width: '38px', height: '38px', padding: 0 }}
                                onClick={() => {
                                  setRecordingModalType('video');
                                  setShowRecordingModal(true);
                                }}
                              >
                                <FontAwesomeIcon icon={faVideo} />
                              </Button>
                            </OverlayTrigger>
                          </>
                        )}
                      </div>
                    </Card.Body>
                  </Card>
                </Col>

                {/* Konuşma Notları - MessageReplyScreen'deki gibi */}
                <Col md={12} className="mb-3">
                  <Card className="border-0 shadow-sm">
                    <Card.Body>
                      <h6 className="mb-3">Konuşma Notları</h6>

                      {/* Filtre butonları */}
                      <div className="d-flex gap-2 mb-3">
                        <Button
                          variant={noteFilter === 'all' ? 'primary' : 'outline-primary'}
                          size="sm"
                          onClick={() => setNoteFilter('all')}
                        >
                          Hepsi
                        </Button>
                        <Button
                          variant={noteFilter === 'member' ? 'primary' : 'outline-primary'}
                          size="sm"
                          onClick={() => setNoteFilter('member')}
                          style={{ backgroundColor: noteFilter === 'member' ? '#6f42c1' : undefined, borderColor: '#6f42c1' }}
                        >
                          Üye
                        </Button>
                        <Button
                          variant={noteFilter === 'bot' ? 'primary' : 'outline-primary'}
                          size="sm"
                          onClick={() => setNoteFilter('bot')}
                          style={{ backgroundColor: noteFilter === 'bot' ? '#28a745' : undefined, borderColor: '#28a745' }}
                        >
                          Bot
                        </Button>
                      </div>

                      {/* Manuel not ekleme */}
                      <div className="mb-3">
                        <InputGroup size="sm">
                          <Button
                            variant={noteType === 'bot' ? 'success' : 'outline-success'}
                            onClick={() => setNoteType('bot')}
                          >
                            Bot
                          </Button>
                          <Button
                            variant={noteType === 'member' ? 'primary' : 'outline-primary'}
                            onClick={() => setNoteType('member')}
                            style={{ backgroundColor: noteType === 'member' ? '#6f42c1' : undefined, borderColor: '#6f42c1' }}
                          >
                            Üye
                          </Button>
                          <Form.Control
                            type="text"
                            placeholder="Not ekle..."
                            value={noteContent}
                            onChange={(e) => setNoteContent(e.target.value)}
                            onKeyPress={(e) => {
                              if (e.key === 'Enter') handleAddManualNote();
                            }}
                          />
                          <Button variant="primary" onClick={handleAddManualNote}>
                            <FontAwesomeIcon icon={faPlus} />
                          </Button>
                        </InputGroup>
                      </div>

                      {/* Notlar listesi */}
                      <div className="overflow-auto" style={{ maxHeight: '200px' }}>
                        {conversationNotes
                          .filter(note => noteFilter === 'all' || note.type === noteFilter)
                          .map((note) => (
                            <div
                              key={note.id}
                              className="d-flex align-items-start justify-content-between mb-2 p-2 rounded"
                              style={{
                                backgroundColor: note.type === 'bot' ? '#d4edda' : '#e7d5f8',
                                border: `1px solid ${note.type === 'bot' ? '#28a745' : '#6f42c1'}`,
                                fontSize: '0.8rem'
                              }}
                            >
                              <div className="d-flex align-items-start gap-2" style={{ flex: 1, minWidth: 0 }}>
                                <Badge bg={note.type === 'bot' ? 'success' : 'primary'} style={{ fontSize: '0.6rem' }}>
                                  {note.type === 'bot' ? 'BOT' : 'ÜYE'}
                                </Badge>
                                <span className="text-dark" style={{ wordBreak: 'break-word' }}>{note.content}</span>
                              </div>
                              <Button
                                variant="link"
                                size="sm"
                                className="p-0 ms-2 text-danger"
                                onClick={() => handleDeleteConversationNote(note.id)}
                              >
                                <FontAwesomeIcon icon={faTrash} size="xs" />
                              </Button>
                            </div>
                          ))}
                        {conversationNotes.length === 0 && (
                          <p className="text-center text-muted small mt-2">Henüz not yok.</p>
                        )}
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Col >
          </>
        ) : (
          <Col md={9} className="mb-4">
            <Card className="border-0 shadow-sm">
              <Card.Body className="text-center py-5">
                <p className="text-muted">Bir mesaj seçin</p>
              </Card.Body>
            </Card>
          </Col>
        )
        }
      </Row >

      {/* Modals - MessageReplyScreen'deki modalların aynısı */}
      < Modal show={showCreditsModal} onHide={() => setShowCreditsModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Jeton Ekle/Sil</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>
              Jeton Değişikliği (Mevcut: {targetUserId === currentSenderId ? userCredits : testUserCredits})
              <br />
              <small className="text-muted">Pozitif değer ekler, negatif değer çıkarır</small>
            </Form.Label>
            <Form.Control
              ref={creditsInputRef}
              type="number"
              value={creditsInput}
              onChange={(e) => setCreditsInput(e.target.value)}
              placeholder="Örn: 100 veya -50"
              autoFocus
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  handleUpdateCredits();
                }
              }}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowCreditsModal(false)}>
            İptal
          </Button>
          <Button variant="primary" onClick={handleUpdateCredits}>
            Kaydet
          </Button>
        </Modal.Footer>
      </Modal >

      <Modal show={showDiamondModal} onHide={() => setShowDiamondModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Diamond Üye Yap</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Bu üyeyi Diamond üye yapmak istediğinizden emin misiniz?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDiamondModal(false)}>
            İptal
          </Button>
          <Button variant="primary" onClick={handleSetDiamond}>
            Evet, Diamond Yap
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showPremiumModal} onHide={() => setShowPremiumModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Premium Yap/Kaldır</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>Premium Gün Sayısı (0 = Premium'u Kaldır)</Form.Label>
            <Form.Control
              ref={premiumInputRef}
              type="number"
              value={premiumDaysInput}
              onChange={(e) => setPremiumDaysInput(e.target.value)}
              placeholder="10"
              min="0"
              autoFocus
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  handleUpdatePremium();
                }
              }}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowPremiumModal(false)}>
            İptal
          </Button>
          <Button variant="primary" onClick={handleUpdatePremium}>
            Kaydet
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showBanModal} onHide={() => setShowBanModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Kullanıcıyı Banla</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Bu kullanıcıyı banlamak istediğinizden emin misiniz?
          Banlanan kullanıcılar uygulamaya giriş yapamaz.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowBanModal(false)}>
            İptal
          </Button>
          <Button variant="danger" onClick={handleBanUser}>
            Evet, Banla
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showCallModal} onHide={() => setShowCallModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Arama Başlat</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Arama Türü</Form.Label>
            <Form.Select
              value={callType}
              onChange={(e) => { setCallType(e.target.value); setSelectedRecordingIndex(0); }}
            >
              <option value="normal_voice">Normal Sesli Arama</option>
              <option value="recorded_voice">Canlı Sesli Arama (Kayıtlı)</option>
              <option value="recorded_video">Video Araması (Kayıtlı)</option>
            </Form.Select>
          </Form.Group>
          {callType === 'normal_voice' && (
            <Alert variant="info">
              Normal sesli arama başlatılacak. Kayıt gerekmez.
            </Alert>
          )}
          {callType === 'recorded_voice' && (
            <>
              {audioRecordings.length === 0 ? (
                <Alert variant="danger">Ses kaydı bulunamadı. Lütfen önce ses kaydı ekleyin.</Alert>
              ) : (
                <Form.Group className="mb-3">
                  <Form.Label>Ses Kaydı Seçin</Form.Label>
                  <Form.Select
                    value={selectedRecordingIndex}
                    onChange={(e) => setSelectedRecordingIndex(Number(e.target.value))}
                  >
                    {audioRecordings.map((rec, idx) => (
                      <option key={idx} value={idx}>
                        {rec.title || rec.fileName || `Ses Kaydı ${idx + 1}`}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              )}
            </>
          )}
          {callType === 'recorded_video' && (
            <>
              {videoRecordings.length === 0 ? (
                <Alert variant="danger">Video kaydı bulunamadı. Lütfen önce video kaydı ekleyin.</Alert>
              ) : (
                <Form.Group className="mb-3">
                  <Form.Label>Video Kaydı Seçin</Form.Label>
                  <Form.Select
                    value={selectedRecordingIndex}
                    onChange={(e) => setSelectedRecordingIndex(Number(e.target.value))}
                  >
                    {videoRecordings.map((rec, idx) => (
                      <option key={idx} value={idx}>
                        {rec.title || rec.fileName || `Video Kaydı ${idx + 1}`}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              )}
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowCallModal(false)}>
            İptal
          </Button>
          <Button variant="primary" onClick={handleStartCall}>
            Aramayı Başlat
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showQuickMessageModal} onHide={() => {
        setShowQuickMessageModal(false);
        setEditingQuickMessage(null);
        setQuickMessageTitle("");
        setQuickMessageContent("");
        setIsSmart(false);
      }}>
        <Modal.Header closeButton>
          <Modal.Title>
            {editingQuickMessage ? 'Hızlı Mesaj Düzenle' : 'Yeni Hızlı Mesaj'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Başlık (Panel İçin)</Form.Label>
            <Form.Control
              type="text"
              value={quickMessageTitle}
              onChange={(e) => setQuickMessageTitle(e.target.value)}
              placeholder="Örn: Selamlaşma"
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Mesaj İçeriği</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              value={quickMessageContent}
              onChange={(e) => setQuickMessageContent(e.target.value)}
              placeholder="Mesaj içeriğini yazın..."
              onKeyDown={(e) => {
                if (e.key === 'Enter' && !e.shiftKey) {
                  e.preventDefault();
                  handleSaveQuickMessage();
                }
              }}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Check
              type="checkbox"
              id="isSmartQuick"
              label="Akıllı Mesaj (Değişkenleri otomatik doldurur)"
              checked={isSmart}
              onChange={(e) => setIsSmart(e.target.checked)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => {
            setShowQuickMessageModal(false);
            setEditingQuickMessage(null);
            setQuickMessageTitle("");
            setQuickMessageContent("");
            setIsSmart(false);
          }}>
            İptal
          </Button>
          <Button variant="primary" onClick={handleSaveQuickMessage}>
            {editingQuickMessage ? 'Güncelle' : 'Kaydet'}
          </Button>
        </Modal.Footer>
      </Modal >

      <Modal show={showVipPhoneModal} onHide={() => setShowVipPhoneModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            <FontAwesomeIcon icon={faCrown} className="me-2 text-warning" />
            Paket Mesajı Gönder
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Paket seçiniz</Form.Label>
            <Form.Select
              value={vipPhoneSelectedSku}
              onChange={(e) => setVipPhoneSelectedSku(e.target.value)}
            >
              <option value="">Paket seçiniz...</option>
              {vipPackages.map((pkg) => (
                <option key={pkg.id} value={pkg.sku}>
                  [{pkg.type}] {pkg.packageName} - {pkg.price} TL
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <Form.Label className="mb-0">Mesaj İçeriği</Form.Label>
              <Button
                variant="outline-primary"
                size="xs"
                className="py-0 px-2"
                onClick={() => setShowVipTemplateModal(true)}
              >
                <FontAwesomeIcon icon={faPlus} className="me-1" /> Şablon Ekle
              </Button>
            </div>

            {/* VIP Şablonları */}
            {vipTemplates.length > 0 && (
              <div className="d-flex flex-wrap gap-2 mb-3">
                {vipTemplates.map((template) => (
                  <div key={template.id} className="d-flex align-items-center bg-light border rounded-pill px-3 py-1">
                    <span
                      className="cursor-pointer text-primary"
                      style={{ fontSize: '13px', fontWeight: '500' }}
                      onClick={() => setVipPhoneMessage(template.content)}
                    >
                      {template.title}
                    </span>
                    <FontAwesomeIcon
                      icon={faEdit}
                      className="ms-2 text-muted cursor-pointer"
                      style={{ fontSize: '11px' }}
                      onClick={() => {
                        setEditingVipTemplate(template);
                        setVipTemplateTitle(template.title);
                        setVipTemplateContent(template.content);
                        setShowVipTemplateModal(true);
                      }}
                    />
                    <FontAwesomeIcon
                      icon={faTrash}
                      className="ms-2 text-danger cursor-pointer"
                      style={{ fontSize: '11px' }}
                      onClick={() => handleDeleteVipTemplate(template.id)}
                    />
                  </div>
                ))}
              </div>
            )}

            <Form.Control
              as="textarea"
              rows={4}
              value={vipPhoneMessage}
              onChange={(e) => setVipPhoneMessage(e.target.value)}
              placeholder="Mesaj içeriğini yazın..."
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowVipPhoneModal(false)}>
            İptal
          </Button>
          <Button
            variant="warning"
            onClick={handleSendVipPhoneMessage}
            disabled={!vipPhoneMessage.trim() || !vipPhoneSelectedSku || vipPhoneSending}
          >
            {vipPhoneSending ? (
              <>
                <FontAwesomeIcon icon={faSpinner} className="fa-spin me-2" />
                Gönderiliyor...
              </>
            ) : (
              <>
                <FontAwesomeIcon icon={faStar} className="me-2" />
                Sistem Mesajı Gönder
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showSystemMessageModal} onHide={() => setShowSystemMessageModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Sistem Mesajı Gönder</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>Mesaj İçeriği</Form.Label>
            <Form.Control
              as="textarea"
              rows={5}
              value={systemMessageText}
              onChange={(e) => setSystemMessageText(e.target.value)}
              placeholder="Kullanıcıya gönderilecek sistem mesajını yazın..."
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowSystemMessageModal(false)}>
            İptal
          </Button>
          <Button
            variant="primary"
            onClick={handleSendManualSystemMessage}
            disabled={sending || !systemMessageText.trim()}
          >
            {sending ? <FontAwesomeIcon icon={faSpinner} spin className="me-2" /> : null}
            Gönder
          </Button>
        </Modal.Footer>
      </Modal>

      {/* VIP Şablon Ekle/Düzenle Modalı */}
      <Modal show={showVipTemplateModal} onHide={() => {
        setShowVipTemplateModal(false);
        setEditingVipTemplate(null);
        setVipTemplateTitle("");
        setVipTemplateContent("");
      }}>
        <Modal.Header closeButton>
          <Modal.Title>
            {editingVipTemplate ? 'Şablon Düzenle' : 'Yeni Şablon Ekle'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Şablon Başlığı</Form.Label>
            <Form.Control
              type="text"
              value={vipTemplateTitle}
              onChange={(e) => setVipTemplateTitle(e.target.value)}
              placeholder="Örn: VIP Bilgilendirme 1"
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Şablon İçeriği</Form.Label>
            <Form.Control
              as="textarea"
              rows={5}
              value={vipTemplateContent}
              onChange={(e) => setVipTemplateContent(e.target.value)}
              placeholder="Şablon içeriğini buraya yazın..."
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => {
            setShowVipTemplateModal(false);
            setEditingVipTemplate(null);
            setVipTemplateTitle("");
            setVipTemplateContent("");
          }}>
            İptal
          </Button>
          <Button variant="primary" onClick={handleSaveVipTemplate}>
            {editingVipTemplate ? 'Güncelle' : 'Kaydet'}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showNotificationModal} onHide={() => {
        setShowNotificationModal(false);
        setNotificationTitle("");
        setNotificationMessage("");
      }}>
        <Modal.Header closeButton>
          <Modal.Title>Anlık Bildirim Gönder</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Bildirim Başlığı</Form.Label>
            <Form.Control
              type="text"
              value={notificationTitle}
              onChange={(e) => setNotificationTitle(e.target.value)}
              placeholder="Başlık girin..."
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Bildirim Mesajı</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              value={notificationMessage}
              onChange={(e) => setNotificationMessage(e.target.value)}
              placeholder="Mesaj içeriğini yazın..."
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowNotificationModal(false)}>
            İptal
          </Button>
          <Button variant="primary" onClick={handleSendNotification} disabled={notificationSending || !notificationTitle.trim() || !notificationMessage.trim()}>
            {notificationSending ? <FontAwesomeIcon icon={faSpinner} spin className="me-2" /> : null}
            Gönder
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showRecordingModal} onHide={() => setShowRecordingModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            {recordingModalType === 'audio' ? 'Ses Kayıtları' : 'Video Kayıtları'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-4">
            <Form.Group>
              <Form.Label>Yeni {recordingModalType === 'audio' ? 'Ses' : 'Video'} Kaydı Yükle</Form.Label>
              <div className="d-flex gap-2">
                <Form.Control
                  type="file"
                  accept={recordingModalType === 'audio' ? 'audio/*' : 'video/*'}
                  onChange={handleRecordingUpload}
                  disabled={uploading}
                />
                {uploading && <div className="d-flex align-items-center"><FontAwesomeIcon icon={faSpinner} spin className="me-2" /> Yükleniyor...</div>}
              </div>
            </Form.Group>
          </div>

          <Table responsive className="table-centered table-nowrap mb-0 rounded">
            <thead className="thead-light">
              <tr>
                <th className="border-0">Başlık</th>
                <th className="border-0">Önizleme</th>
                <th className="border-0">İşlem</th>
              </tr>
            </thead>
            <tbody>
              {(recordingModalType === 'audio' ? audioRecordings : videoRecordings).map((rec) => (
                <tr key={rec.id}>
                  <td>{rec.title}</td>
                  <td>
                    {recordingModalType === 'audio' ? (
                      <audio src={rec.fileUrl} controls style={{ height: '30px' }} />
                    ) : (
                      <video src={rec.fileUrl} controls style={{ height: '40px' }} />
                    )}
                  </td>
                  <td>
                    <Button variant="link" className="text-danger" onClick={() => handleDeleteRecording(rec.id)}>
                      <FontAwesomeIcon icon={faTrash} />
                    </Button>
                  </td>
                </tr>
              ))}
              {(recordingModalType === 'audio' ? audioRecordings : videoRecordings).length === 0 && (
                <tr>
                  <td colSpan="3" className="text-center py-4">Henüz kayıt bulunmamaktadır.</td>
                </tr>
              )}
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowRecordingModal(false)}>
            Kapat
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Arşiv Fotoğrafları Modal */}
      <Modal show={showArchiveModal} onHide={() => setShowArchiveModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Fotoğraf Arşivi</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="text-muted mb-3">
            Fotoğrafa tıklayarak mesaj olarak gönderebilirsiniz. Yeni fotoğraf eklemek için aşağıdaki butonu kullanın.
          </p>

          {/* Fotoğraf Yükleme */}
          <div className="mb-4">
            <Form.Group>
              <Form.Label>Yeni Fotoğraf Ekle (Birden fazla seçebilirsiniz)</Form.Label>
              <Form.Control
                type="file"
                accept="image/*"
                multiple
                onChange={(e) => {
                  if (e.target.files && e.target.files.length > 0) {
                    handleUploadArchivePhoto(e.target.files);
                    e.target.value = '';
                  }
                }}
                disabled={archiveUploading}
              />
            </Form.Group>
            {archiveUploading && (
              <div className="text-center mt-2">
                <FontAwesomeIcon icon={faSpinner} className="fa-spin me-2" />
                Yükleniyor...
              </div>
            )}
          </div>

          {/* Fotoğraf Listesi */}
          <div className="d-flex flex-wrap gap-3">
            {archivePhotos.length === 0 ? (
              <div className="text-center py-4 w-100">
                <p className="text-muted">Henüz arşivde fotoğraf yok.</p>
              </div>
            ) : (
              archivePhotos.map((photo) => (
                <div
                  key={photo.id}
                  style={{
                    position: 'relative',
                    width: '120px',
                    height: '120px',
                    cursor: 'pointer',
                    border: '2px solid #dee2e6',
                    borderRadius: '8px',
                    overflow: 'hidden'
                  }}
                >
                  <img
                    src={photo.url}
                    alt="Arşiv Fotoğrafı"
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    onClick={() => handleSendArchivePhoto(photo.url)}
                  />
                  <Button
                    variant="danger"
                    size="sm"
                    style={{
                      position: 'absolute',
                      top: '4px',
                      right: '4px',
                      width: '24px',
                      height: '24px',
                      padding: 0,
                      borderRadius: '50%'
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDeleteArchivePhoto(photo.id);
                    }}
                  >
                    <FontAwesomeIcon icon={faTimes} style={{ fontSize: '10px' }} />
                  </Button>
                </div>
              ))
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowArchiveModal(false)}>
            Kapat
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Hediye Seçici Modal */}
      <Modal show={showGiftModal} onHide={() => setShowGiftModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>🎁 Hediye Gönder — {testUserInfo?.name} adına</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {giftsLoading ? (
            <div className="text-center py-4"><FontAwesomeIcon icon={faSpinner} className="fa-spin fa-2x" /></div>
          ) : gifts.length === 0 ? (
            <p className="text-muted text-center">Aktif hediye bulunamadı.</p>
          ) : (
            <div className="d-flex flex-wrap gap-3 justify-content-center">
              {gifts.map(gift => (
                <div key={gift.id} className="text-center" style={{ width: 110 }}>
                  {gift.imageUrl && (
                    <img src={gift.imageUrl} alt={gift.name} style={{ width: 70, height: 70, objectFit: 'contain' }} className="mb-1" />
                  )}
                  <div style={{ fontSize: '0.8rem', fontWeight: 600 }}>{gift.name}</div>
                  <div style={{ fontSize: '0.75rem', color: '#888' }}>{gift.cost} kredi</div>
                  <Button
                    variant="warning"
                    size="sm"
                    className="mt-1 w-100"
                    disabled={!!sendingGift}
                    onClick={() => handleSendGift(gift)}
                  >
                    {sendingGift === gift.id
                      ? <FontAwesomeIcon icon={faSpinner} className="fa-spin" />
                      : 'Gönder'}
                  </Button>
                </div>
              ))}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowGiftModal(false)}>Kapat</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};


